export const ButtonLinkIconColor = ({
  width = 48,
  height = 48,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_31008_384139)">
      <rect
        width="48"
        height="48"
        rx="8"
        fill="#0A72FB"
      />
      <g filter="url(#filter1_dii_31008_384139)">
        <path
          d="M25.224 30.1158L20.3278 35.012C20.3278 35.012 20.3278 35.0122 20.3277 35.0122C20.3277 35.0122 20.3277 35.0123 20.3276 35.0123C18.3029 37.0371 15.0082 37.0372 12.9833 35.0123C12.0023 34.0313 11.4622 32.7271 11.4622 31.34C11.4622 29.9531 12.0023 28.6491 12.9829 27.6681C12.9831 27.668 12.9832 27.6679 12.9833 27.6678L17.8794 22.7715C18.5554 22.0954 18.5554 20.9993 17.8793 20.3234C17.2034 19.6474 16.1072 19.6474 15.4312 20.3234L10.535 25.2196C10.5347 25.22 10.5343 25.2204 10.534 25.2208C8.89995 26.8554 8 29.0286 8 31.34C8 33.652 8.90029 35.8256 10.5352 37.4604C12.2226 39.1478 14.439 39.9915 16.6555 39.9915C18.8721 39.9915 21.0886 39.1478 22.7758 37.4604V37.4603C22.7759 37.4603 22.7759 37.4602 22.7759 37.4602L27.6721 32.5639C28.348 31.888 28.348 30.7918 27.672 30.1158C26.9961 29.4398 25.9001 29.4398 25.224 30.1158Z"
          fill="white"
        />
        <path
          d="M39.9998 16.6514C39.9998 14.3394 39.0994 12.1659 37.4645 10.531C34.0897 7.15627 28.5985 7.15639 25.2239 10.531C25.2237 10.5312 25.2235 10.5314 25.2234 10.5316L20.3274 15.4275C19.6513 16.1034 19.6513 17.1997 20.3274 17.8756C20.6655 18.2138 21.1084 18.3827 21.5515 18.3827C21.9944 18.3827 22.4376 18.2137 22.7755 17.8756L27.6715 12.9797C27.6716 12.9795 27.6719 12.9794 27.6721 12.9791C29.6968 10.9544 32.9915 10.9543 35.0164 12.9791C35.9972 13.9601 36.5376 15.2643 36.5376 16.6514C36.5376 18.0384 35.9975 19.3424 35.0167 20.3233C35.0166 20.3234 35.0165 20.3235 35.0164 20.3237L30.1202 25.2199C29.4443 25.8959 29.4443 26.992 30.1203 27.6681C30.4584 28.0061 30.9014 28.1752 31.3444 28.1752C31.7874 28.1752 32.2305 28.0061 32.5685 27.6681L37.4646 22.7718C37.465 22.7714 37.4653 22.771 37.4657 22.7706C39.0997 21.136 39.9998 18.9628 39.9998 16.6514Z"
          fill="white"
        />
        <path
          d="M17.8796 30.1158C18.2176 30.4538 18.6607 30.6229 19.1036 30.6229C19.5467 30.6229 19.9897 30.4538 20.3277 30.1158L30.1203 20.3233C30.7963 19.6473 30.7963 18.5512 30.1203 17.8751C29.4443 17.1992 28.3482 17.1992 27.6721 17.8751L17.8796 27.6675C17.2035 28.3437 17.2035 29.4398 17.8796 30.1158Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_31008_384139"
        x="0"
        y="0"
        width="48"
        height="56.2843"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8.28426" />
        <feGaussianBlur stdDeviation="10.2335" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_31008_384139"
        />
      </filter>
      <filter
        id="filter1_dii_31008_384139"
        x="6.76"
        y="7.13"
        width="34.605"
        height="34.985"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.75" />
        <feGaussianBlur stdDeviation="0.62" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_31008_384139"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_31008_384139"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.87" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0392157 0 0 0 0 0.447059 0 0 0 0 0.984314 0 0 0 0.35 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_31008_384139"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.25" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_31008_384139"
          result="effect3_innerShadow_31008_384139"
        />
      </filter>
    </defs>
  </svg>
);

export const ImageIconColor = ({
  width = 48,
  height = 48,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_31008_384171)">
      <rect
        width="48"
        height="48"
        rx="8"
        fill="#FC7B03"
      />
      <g filter="url(#filter1_dii_31008_384171)">
        <path
          d="M36.3825 9H11.6193C9.6232 9 8 10.6227 8 12.6211V35.38C8 37.3761 9.6232 38.9971 11.6193 38.9971H36.3824C38.3785 38.9971 40 37.3761 40 35.38V12.6211C40.0001 10.6227 38.3786 9 36.3825 9ZM28.6929 14.3853C30.6232 14.3853 32.1887 15.9508 32.1887 17.881C32.1887 19.8112 30.6231 21.3768 28.6929 21.3768C26.762 21.3768 25.1971 19.8112 25.1971 17.881C25.1971 15.9508 26.762 14.3853 28.6929 14.3853ZM35.2475 35.6515H13.2531C12.2876 35.6515 11.8576 34.9529 12.2929 34.0912L18.2922 22.2083C18.7269 21.3466 19.5554 21.2697 20.1421 22.0364L26.1747 29.92C26.7614 30.6868 27.7869 30.752 28.4656 30.065L29.9414 28.5706C30.6196 27.8836 31.6188 27.9687 32.1723 28.7593L35.9938 34.2181C36.5462 35.0099 36.213 35.6515 35.2475 35.6515Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_31008_384171"
        x="0"
        y="0"
        width="48"
        height="56.2843"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8.28426" />
        <feGaussianBlur stdDeviation="10.2335" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_31008_384171"
        />
      </filter>
      <filter
        id="filter1_dii_31008_384171"
        x="6.76"
        y="7.13"
        width="34.605"
        height="34.985"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.75" />
        <feGaussianBlur stdDeviation="0.62" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_31008_384171"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_31008_384171"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.87" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.988235 0 0 0 0 0.482353 0 0 0 0 0.0117647 0 0 0 0.35 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_31008_384171"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.25" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_31008_384171"
          result="effect3_innerShadow_31008_384171"
        />
      </filter>
    </defs>
  </svg>
);

export const TextIconColor = ({
  width = 48,
  height = 48,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_31008_384199)">
      <rect
        width="48"
        height="48"
        rx="8"
        fill="#6452FF"
      />
      <g filter="url(#filter1_dii_31008_384199)">
        <path
          d="M34 8H14.6667C12.644 8 11 9.644 11 11.6667V36.3333C11 38.356 12.644 40 14.6667 40H34C36.0227 40 37.6667 38.356 37.6667 36.3333V11.6667C37.6667 9.644 36.0227 8 34 8ZM15 19.6667C15 19.1147 15.448 18.6667 16 18.6667H23.3333C23.8853 18.6667 24.3333 19.1147 24.3333 19.6667V21C24.3333 21.552 23.8853 22 23.3333 22C22.7813 22 22.3333 21.552 22.3333 21C22.3333 20.8159 22.1841 20.6667 22 20.6667H21.5C21.0398 20.6667 20.6667 21.0398 20.6667 21.5V25C20.6667 25.5523 21.2093 25.9953 21.5082 26.4598C21.6085 26.6156 21.6667 26.801 21.6667 27C21.6667 27.552 21.2187 28 20.6667 28H18.6667C18.1147 28 17.6667 27.552 17.6667 27C17.6667 26.801 17.7249 26.6156 17.8252 26.4598C18.1241 25.9953 18.6667 25.5523 18.6667 25V21.5C18.6667 21.0398 18.2936 20.6667 17.8333 20.6667H17.3333C17.1492 20.6667 17 20.8159 17 21C17 21.552 16.552 22 16 22C15.448 22 15 21.552 15 21V19.6667ZM32.6667 36H16C15.448 36 15 35.552 15 35C15 34.448 15.448 34 16 34H32.6667C33.2187 34 33.6667 34.448 33.6667 35C33.6667 35.552 33.2187 36 32.6667 36ZM32.6667 32H16C15.448 32 15 31.552 15 31C15 30.448 15.448 30 16 30H32.6667C33.2187 30 33.6667 30.448 33.6667 31C33.6667 31.552 33.2187 32 32.6667 32ZM32.6667 28H28C27.448 28 27 27.552 27 27C27 26.448 27.448 26 28 26H32.6667C33.2187 26 33.6667 26.448 33.6667 27C33.6667 27.552 33.2187 28 32.6667 28ZM32.6667 24.3333H28C27.448 24.3333 27 23.8853 27 23.3333C27 22.7813 27.448 22.3333 28 22.3333H32.6667C33.2187 22.3333 33.6667 22.7813 33.6667 23.3333C33.6667 23.8853 33.2187 24.3333 32.6667 24.3333ZM32.6667 20.6667H28C27.448 20.6667 27 20.2187 27 19.6667C27 19.1147 27.448 18.6667 28 18.6667H32.6667C33.2187 18.6667 33.6667 19.1147 33.6667 19.6667C33.6667 20.2187 33.2187 20.6667 32.6667 20.6667Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_31008_384199"
        x="0"
        y="0"
        width="48"
        height="56.2843"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8.28426" />
        <feGaussianBlur stdDeviation="10.2335" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_31008_384199"
        />
      </filter>
      <filter
        id="filter1_dii_31008_384199"
        x="6.76"
        y="7.13"
        width="34.605"
        height="34.985"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.75" />
        <feGaussianBlur stdDeviation="0.62" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_31008_384199"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_31008_384199"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.87" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.439216 0 0 0 0 0.372549 0 0 0 0 1 0 0 0 0.35 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_31008_384199"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.25" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_31008_384199"
          result="effect3_innerShadow_31008_384199"
        />
      </filter>
    </defs>
  </svg>
);

export const BioIconColor = ({ width = 48, height = 48 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_31008_384236)">
      <rect
        width="48"
        height="48"
        rx="8"
        fill="#12AD56"
      />
      <g filter="url(#filter1_dii_31008_384236)">
        <path
          d="M18.9966 23.6548C20.4175 24.6926 22.1721 25.2981 24.0625 25.2981C28.686 25.2981 32.7115 21.296 32.7115 16.649C32.7115 11.8797 28.8318 8 24.0625 8C19.2932 8 15.4135 11.8797 15.4135 16.649C15.4135 19.5279 16.822 22.0856 18.9966 23.6548Z"
          fill="white"
        />
        <path
          d="M31.6737 24.7421C29.6844 26.6201 27.0032 27.7692 24.0625 27.7692C21.1218 27.7692 18.4406 26.6201 16.4513 24.7421C11.4225 27.4603 8 32.7857 8 38.8894C8 39.569 8.55601 40.125 9.23558 40.125H38.8894C39.569 40.125 40.125 39.569 40.125 38.8894C40.125 32.7857 36.7024 27.4603 31.6737 24.7421Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_31008_384236"
        x="0"
        y="0"
        width="48"
        height="56.2843"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8.28426" />
        <feGaussianBlur stdDeviation="10.2335" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_31008_384236"
        />
      </filter>
      <filter
        id="filter1_dii_31008_384236"
        x="6.76"
        y="7.13"
        width="34.605"
        height="34.985"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.75" />
        <feGaussianBlur stdDeviation="0.62" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_31008_384236"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_31008_384236"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.87" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.113725 0 0 0 0 0.67451 0 0 0 0 0.360784 0 0 0 0.35 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_31008_384236"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.25" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_31008_384236"
          result="effect3_innerShadow_31008_384236"
        />
      </filter>
    </defs>
  </svg>
);

export const SpotLightIconColor = ({ width = 48, height = 48 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_31008_384264)">
      <rect
        width="48"
        height="48"
        rx="8"
        fill="#FAB500"
      />
      <g filter="url(#filter1_dii_31008_384264)">
        <path
          d="M33.8775 18.6043L28.5944 17.8365L26.2318 13.0486C25.3196 11.1997 22.6807 11.199 21.7681 13.0485L19.4054 17.8365L14.1224 18.6043C12.0824 18.9007 11.2664 21.4104 12.743 22.8502L16.5659 26.5771L15.6635 31.8396C15.315 33.8715 17.4491 35.4233 19.2747 34.4637L23.9999 31.979L28.7253 34.4637C30.553 35.4246 32.6841 33.867 32.3363 31.8396L31.4339 26.5771L35.2568 22.8502C36.7329 21.4109 35.9183 18.9009 33.8775 18.6043Z"
          fill="white"
        />
        <path
          d="M16.4206 12.1958L15.145 10.4398C14.7986 9.96321 14.1316 9.8575 13.6551 10.2039C13.1785 10.5502 13.0729 11.2173 13.4191 11.694L14.6948 13.45C15.0413 13.9268 15.7085 14.0322 16.1847 13.6859C16.6613 13.3397 16.7669 12.6724 16.4206 12.1958Z"
          fill="white"
        />
        <path
          d="M12.1873 27.933C12.0052 27.3727 11.4036 27.0658 10.8432 27.2481L8.73729 27.9325C8.17704 28.1145 7.87048 28.7164 8.05248 29.2768C8.23485 29.8382 8.83773 30.1435 9.39654 29.9617L11.5025 29.2773C12.0628 29.0953 12.3694 28.4934 12.1873 27.933Z"
          fill="white"
        />
        <path
          d="M34.3449 10.2039C33.8684 9.8575 33.2013 9.96314 32.855 10.4398L31.5793 12.1958C31.233 12.6724 31.3387 13.3397 31.8153 13.6859C32.292 14.0323 32.959 13.9265 33.3052 13.45L34.5809 11.694C34.9272 11.2173 34.8215 10.5502 34.3449 10.2039Z"
          fill="white"
        />
        <path
          d="M39.2627 27.9325L37.1567 27.2481C36.5964 27.0657 35.9947 27.3727 35.8126 27.933C35.6306 28.4933 35.9371 29.0952 36.4974 29.2773L38.6034 29.9617C39.1626 30.1436 39.7652 29.8379 39.9475 29.2768C40.1295 28.7164 39.8229 28.1146 39.2627 27.9325Z"
          fill="white"
        />
        <path
          d="M24 36.2029C23.4109 36.2029 22.9334 36.6805 22.9334 37.2697V39.4349C22.9334 40.0241 23.4109 40.5017 24 40.5017C24.589 40.5017 25.0666 40.0241 25.0666 39.4349V37.2697C25.0667 36.6805 24.5891 36.2029 24 36.2029Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_31008_384264"
        x="0"
        y="0"
        width="48"
        height="56.2843"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8.28426" />
        <feGaussianBlur stdDeviation="10.2335" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_31008_384264"
        />
      </filter>
      <filter
        id="filter1_dii_31008_384264"
        x="6.76"
        y="8.13"
        width="34.605"
        height="34.9899"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.75" />
        <feGaussianBlur stdDeviation="0.62" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_31008_384264"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_31008_384264"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.87" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.764706 0 0 0 0 0.141176 0 0 0 0.35 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_31008_384264"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.25" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_31008_384264"
          result="effect3_innerShadow_31008_384264"
        />
      </filter>
    </defs>
  </svg>
);

export const ImageSliderIconColor = ({ width = 48, height = 48 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_36939_305395)">
      <rect
        width="48"
        height="48"
        rx="8"
        fill="#FC7B03"
      />
      <g filter="url(#filter1_dii_36939_305395)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 10.5263C9 9.13107 10.1311 8 11.5263 8H36.7895C38.1847 8 39.3158 9.13107 39.3158 10.5263V30.7368C39.3158 32.132 38.1847 33.2632 36.7895 33.2632H11.5263C10.1311 33.2632 9 32.132 9 30.7368V10.5263ZM22.4737 14.7368C22.4737 16.5972 20.9656 18.1053 19.1053 18.1053C17.2449 18.1053 15.7368 16.5972 15.7368 14.7368C15.7368 12.8765 17.2449 11.3684 19.1053 11.3684C20.9656 11.3684 22.4737 12.8765 22.4737 14.7368ZM33.54 29.8947H14.7707C14.1788 29.8947 13.8468 29.2749 14.1933 28.8303L19.3223 23.3721C19.5965 23.0892 20.0729 23.0892 20.3616 23.3587L22.7147 25.8526L27.132 19.4108C27.4352 19.0066 28.0703 19.0201 28.3445 19.4378L34.1752 28.8842C34.4349 29.3423 34.0885 29.8947 33.54 29.8947Z"
          fill="white"
        />
        <path
          d="M17.421 40.3684C18.3512 40.3684 19.1052 39.6144 19.1052 38.6842C19.1052 37.754 18.3512 37 17.421 37C16.4909 37 15.7368 37.754 15.7368 38.6842C15.7368 39.6144 16.4909 40.3684 17.421 40.3684Z"
          fill="white"
        />
        <path
          d="M25.8421 38.6842C25.8421 39.6144 25.088 40.3684 24.1578 40.3684C23.2277 40.3684 22.4736 39.6144 22.4736 38.6842C22.4736 37.754 23.2277 37 24.1578 37C25.088 37 25.8421 37.754 25.8421 38.6842Z"
          fill="white"
        />
        <path
          d="M30.8951 40.3684C31.8253 40.3684 32.5794 39.6144 32.5794 38.6842C32.5794 37.754 31.8253 37 30.8951 37C29.965 37 29.2109 37.754 29.2109 38.6842C29.2109 39.6144 29.965 40.3684 30.8951 40.3684Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_36939_305395"
        x="0"
        y="0"
        width="48"
        height="56.2843"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8.28426" />
        <feGaussianBlur stdDeviation="10.2335" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_36939_305395"
        />
      </filter>
      <filter
        id="filter1_dii_36939_305395"
        x="6.76"
        y="7.13"
        width="34.605"
        height="35.2284"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.75" />
        <feGaussianBlur stdDeviation="0.62" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_36939_305395"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_36939_305395"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.87" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.988235 0 0 0 0 0.482353 0 0 0 0 0.0117647 0 0 0 0.35 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_36939_305395"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.25" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_36939_305395"
          result="effect3_innerShadow_36939_305395"
        />
      </filter>
    </defs>
  </svg>
);

export const MultiLinksIconColor = ({ width = 48, height = 48 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_31008_384329)">
      <rect
        width="48"
        height="48"
        rx="8"
        fill="#345ECA"
      />
      <g filter="url(#filter1_dii_31008_384329)">
        <path
          d="M14.67 19.0638C13.4954 20.2384 11.2783 22.4556 10.2746 23.4592C8.8188 24.9151 8 26.8914 8 28.9516C8 31.0118 8.8188 32.9881 10.2746 34.4455C10.6397 34.809 11.0095 35.1788 11.3731 35.5439C12.8305 36.9997 14.8068 37.8185 16.867 37.8185C18.9272 37.8185 20.9035 36.9997 22.3593 35.5439L26.7547 31.1485C27.3607 30.5426 27.3607 29.5575 26.7547 28.9516C26.1488 28.3456 25.1637 28.3456 24.5578 28.9516C23.3832 30.1262 21.1661 32.3433 20.1624 33.347C19.2892 34.2202 18.1037 34.7111 16.867 34.7111C15.6302 34.7111 14.4447 34.2202 13.5716 33.347C13.2064 32.9819 12.8367 32.6121 12.4715 32.247C11.5984 31.3738 11.1074 30.1883 11.1074 28.9516C11.1074 27.7148 11.5984 26.5294 12.4715 25.6562L16.867 21.2608C17.4729 20.6548 17.4729 19.6698 16.867 19.0638C16.261 18.4579 15.276 18.4579 14.67 19.0638Z"
          fill="white"
        />
        <path
          d="M31.1485 26.7547C32.3231 25.5801 34.5402 23.363 35.5439 22.3593C36.9997 20.9035 37.8185 18.9272 37.8185 16.867C37.8185 14.8068 36.9997 12.8305 35.5439 11.3731C35.1788 11.0095 34.809 10.6397 34.4455 10.2746C32.9881 8.8188 31.0118 8 28.9516 8C26.8914 8 24.9151 8.8188 23.4592 10.2746C22.4556 11.2783 20.2384 13.4954 19.0638 14.67C18.4579 15.276 18.4579 16.261 19.0638 16.867C19.6698 17.4729 20.6548 17.4729 21.2608 16.867C22.4354 15.6924 24.6525 13.4752 25.6562 12.4715C26.5294 11.5984 27.7148 11.1074 28.9516 11.1074C30.1883 11.1074 31.3738 11.5984 32.247 12.4715C32.6121 12.8367 32.9819 13.2064 33.347 13.5716C34.2202 14.4447 34.7111 15.6302 34.7111 16.867C34.7111 18.1037 34.2202 19.2892 33.347 20.1624C32.3433 21.1661 30.1262 23.3832 28.9516 24.5578C28.3456 25.1637 28.3456 26.1488 28.9516 26.7547C29.5575 27.3607 30.5426 27.3607 31.1485 26.7547Z"
          fill="white"
        />
        <path
          d="M18.5157 29.5015L29.5019 18.5152C30.1079 17.9078 30.1079 16.9243 29.5019 16.3168C28.8945 15.7108 27.911 15.7108 27.3035 16.3168L16.3173 27.303C15.7113 27.9105 15.7113 28.894 16.3173 29.5015C16.9247 30.1074 17.9082 30.1074 18.5157 29.5015Z"
          fill="white"
        />
        <path
          d="M33.0099 30.6777L33.0068 38.4462C33.0068 39.3039 33.7029 39.9999 34.5605 39.9999C35.4182 39.9999 36.1142 39.3039 36.1142 38.4462L36.1173 30.6777C36.1173 29.8201 35.4213 29.124 34.5636 29.124C33.706 29.124 33.0099 29.8201 33.0099 30.6777Z"
          fill="white"
        />
        <path
          d="M30.6777 36.1142L38.4462 36.1173C39.3039 36.1173 39.9999 35.4213 39.9999 34.5636C39.9999 33.706 39.3039 33.0099 38.4462 33.0099L30.6777 33.0068C29.8201 33.0068 29.124 33.7029 29.124 34.5605C29.124 35.4182 29.8201 36.1142 30.6777 36.1142Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_31008_384329"
        x="0"
        y="0"
        width="48"
        height="56.2843"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8.28426" />
        <feGaussianBlur stdDeviation="10.2335" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_31008_384329"
        />
      </filter>
      <filter
        id="filter1_dii_31008_384329"
        x="6.76"
        y="7.13"
        width="34.605"
        height="34.985"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.75" />
        <feGaussianBlur stdDeviation="0.62" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_31008_384329"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_31008_384329"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.87" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.203922 0 0 0 0 0.368627 0 0 0 0 0.792157 0 0 0 0.35 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_31008_384329"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.25" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_31008_384329"
          result="effect3_innerShadow_31008_384329"
        />
      </filter>
    </defs>
  </svg>
);

export const CardIconColor = ({ width = 48, height = 48 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_31008_384402)">
      <rect
        width="48"
        height="48"
        rx="8"
        fill="#6452FF"
      />
      <g filter="url(#filter1_dii_31008_384402)">
        <path
          d="M38.7636 8H9.7109C9.02809 8 8.47461 8.47755 8.47461 9.06667V27.2C8.47461 27.7891 9.02809 28.2666 9.7109 28.2666H38.7636C39.4464 28.2666 39.9999 27.7891 39.9999 27.2V9.06667C39.9999 8.47755 39.4464 8 38.7636 8Z"
          fill="white"
        />
        <path
          d="M9.58736 34.5333H28.3788C29.0616 34.5333 29.6151 33.8617 29.6151 33.0333C29.6151 32.2048 29.0616 31.5333 28.3788 31.5333H9.58736C8.90456 31.5333 8.35107 32.2048 8.35107 33.0333C8.35107 33.8617 8.90456 34.5333 9.58736 34.5333Z"
          fill="white"
        />
        <path
          d="M38.2691 36.8667H9.58736C8.90456 36.8667 8.35107 37.5382 8.35107 38.3667C8.35107 39.1952 8.90456 39.8667 9.58736 39.8667H38.2691C38.952 39.8667 39.5054 39.1952 39.5054 38.3667C39.5054 37.5382 38.952 36.8667 38.2691 36.8667Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_31008_384402"
        x="0"
        y="0"
        width="48"
        height="56.2843"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8.28426" />
        <feGaussianBlur stdDeviation="10.2335" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_31008_384402"
        />
      </filter>
      <filter
        id="filter1_dii_31008_384402"
        x="6.76"
        y="7.13"
        width="34.605"
        height="34.985"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.75" />
        <feGaussianBlur stdDeviation="0.62" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_31008_384402"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_31008_384402"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.87" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.462745 0 0 0 0 0.423529 0 0 0 0 1 0 0 0 0.35 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_31008_384402"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.25" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_31008_384402"
          result="effect3_innerShadow_31008_384402"
        />
      </filter>
    </defs>
  </svg>
);

export const EmbedIconColor = ({ width = 48, height = 48 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_31008_384430)">
      <rect
        width="48"
        height="48"
        rx="8"
        fill="#1D59F4"
      />
      <g filter="url(#filter1_dii_31008_384430)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40 8H8V16.0122C8.06062 16.0042 8.12276 16 8.18605 16H39.814C39.8772 16 39.9394 16.0042 40 16.0122V8ZM27.1163 13.9534C27.7328 13.9534 28.2326 13.4537 28.2326 12.8372C28.2326 12.2207 27.7328 11.7209 27.1163 11.7209C26.4998 11.7209 26 12.2207 26 12.8372C26 13.4537 26.4998 13.9534 27.1163 13.9534ZM32.3258 12.8372C32.3258 13.4537 31.826 13.9534 31.2095 13.9534C30.593 13.9534 30.0933 13.4537 30.0933 12.8372C30.0933 12.2207 30.593 11.7209 31.2095 11.7209C31.826 11.7209 32.3258 12.2207 32.3258 12.8372ZM35.3023 13.9534C35.9188 13.9534 36.4186 13.4537 36.4186 12.8372C36.4186 12.2207 35.9188 11.7209 35.3023 11.7209C34.6858 11.7209 34.186 12.2207 34.186 12.8372C34.186 13.4537 34.6858 13.9534 35.3023 13.9534Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40 17.9878C39.9394 17.9958 39.8772 18 39.814 18H8.18605C8.12276 18 8.06062 17.9958 8 17.9878V40H40V17.9878ZM21.1541 33.7263L24.7262 23.01C24.9212 22.4251 25.5537 22.1095 26.1387 22.303C26.7236 22.498 27.0391 23.1306 26.8456 23.7155L23.2735 34.4318C23.0786 35.0167 22.446 35.3322 21.8611 35.1387C21.2761 34.9438 20.9606 34.3112 21.1541 33.7263ZM27.8251 25.9376L30.6069 28.7209L27.8251 31.5042C27.389 31.9388 27.389 32.6472 27.8251 33.0818C28.2597 33.5179 28.9682 33.5179 29.4028 33.0818L32.9749 29.5097C33.411 29.0736 33.411 28.3682 32.9749 27.9321L29.4028 24.36C28.9682 23.9239 28.2597 23.9239 27.8251 24.36C27.389 24.7946 27.389 25.503 27.8251 25.9376ZM15.0253 27.9321L18.5974 24.36C19.032 23.9239 19.7405 23.9239 20.1751 24.36C20.6112 24.7946 20.6112 25.503 20.1751 25.9376L17.3933 28.7209L20.1751 31.5042C20.6112 31.9388 20.6112 32.6472 20.1751 33.0818C19.7405 33.5179 19.032 33.5179 18.5974 33.0818L15.0253 29.5097C14.5892 29.0736 14.5892 28.3682 15.0253 27.9321Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_31008_384430"
        x="0"
        y="0"
        width="48"
        height="56.2843"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8.28426" />
        <feGaussianBlur stdDeviation="10.2335" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_31008_384430"
        />
      </filter>
      <filter
        id="filter1_dii_31008_384430"
        x="6.76"
        y="7.13"
        width="34.605"
        height="34.985"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.75" />
        <feGaussianBlur stdDeviation="0.62" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_31008_384430"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_31008_384430"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.87" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.203922 0 0 0 0 0.368627 0 0 0 0 0.792157 0 0 0 0.35 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_31008_384430"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.25" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_31008_384430"
          result="effect3_innerShadow_31008_384430"
        />
      </filter>
    </defs>
  </svg>
);

export const ImageGalleryIconColor = ({ width = 48, height = 48 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_31008_384496)">
      <rect
        width="48"
        height="48"
        rx="8"
        fill="#FC7B03"
      />
      <g filter="url(#filter1_dii_31008_384496)">
        <path
          d="M19.7893 8H11.7893C9.929 8 8.4209 9.5081 8.4209 11.3684C8.4209 13.2288 9.92899 14.7369 11.7893 14.7369H19.7893C21.6496 14.7369 23.1577 13.2288 23.1577 11.3684C23.1577 9.5081 21.6496 8 19.7893 8Z"
          fill="white"
        />
        <path
          d="M19.1577 16.4211H12.4209C10.2118 16.4211 8.4209 18.2119 8.4209 20.4211V36C8.4209 38.2091 10.2118 40 12.4209 40H19.1577C21.3669 40 23.1577 38.2091 23.1577 36V20.4211C23.1577 18.2119 21.3669 16.4211 19.1577 16.4211Z"
          fill="white"
        />
        <path
          d="M35.5789 24.8421H28.842C26.6329 24.8421 24.842 26.633 24.842 28.8421V36.0001C24.842 38.2092 26.6329 40.0001 28.842 40.0001H35.5789C37.788 40.0001 39.5789 38.2092 39.5789 36.0001V28.8421C39.5789 26.633 37.788 24.8421 35.5789 24.8421Z"
          fill="white"
        />
        <path
          d="M35.5789 8H28.842C26.6329 8 24.842 9.79086 24.842 12V19.1579C24.842 21.3671 26.6334 23.1579 28.8425 23.1579H35.5784C37.7875 23.1579 39.5789 21.3671 39.5789 19.1579V12C39.5789 9.79086 37.788 8 35.5789 8Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_31008_384496"
        x="0"
        y="0"
        width="48"
        height="56.2843"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8.28426" />
        <feGaussianBlur stdDeviation="10.2335" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_31008_384496"
        />
      </filter>
      <filter
        id="filter1_dii_31008_384496"
        x="6.76"
        y="7.13"
        width="34.605"
        height="34.985"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.75" />
        <feGaussianBlur stdDeviation="0.62" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_31008_384496"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_31008_384496"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.87" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.988235 0 0 0 0 0.482353 0 0 0 0 0.0117647 0 0 0 0.35 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_31008_384496"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.25" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_31008_384496"
          result="effect3_innerShadow_31008_384496"
        />
      </filter>
    </defs>
  </svg>
);

export const ImagePopupIcon = ({ className = "", width = 48, height = 48 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g filter="url(#filter0_i_29757_346560)">
        <rect
          width="48"
          height="48"
          rx="8"
          fill="#FC7B03"
        />
        <g filter="url(#filter1_dii_29757_346560)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.9909 11.7429H11.3091C9.48407 11.7429 8 13.2264 8 15.0536V35.8617C8 37.6867 9.48407 39.1687 11.3091 39.1687H33.9497C35.7746 39.1687 37.2571 37.6867 37.2571 35.8617V21.0091C36.3018 21.5141 35.2129 21.8 34.0571 21.8C30.27 21.8 27.2 18.73 27.2 14.9429C27.2 13.7871 27.4859 12.6982 27.9909 11.7429ZM32.912 36.1099H12.8028C11.9201 36.1099 11.527 35.4713 11.9249 34.6833L17.4101 23.819C17.8075 23.0312 18.5649 22.9609 19.1014 23.6618L24.6169 30.8697C25.1533 31.5708 26.0909 31.6304 26.7114 31.0023L28.0607 29.636C28.6807 29.0079 29.5943 29.0857 30.1004 29.8085L33.5943 34.7994C34.0994 35.5234 33.7947 36.1099 32.912 36.1099Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34.0571 20.8857C37.3393 20.8857 40 18.225 40 14.9429C40 11.6607 37.3393 9 34.0571 9C30.775 9 28.1143 11.6607 28.1143 14.9429C28.1143 18.225 30.775 20.8857 34.0571 20.8857ZM36.5716 13.8C36.9503 13.4213 36.9503 12.8073 36.5716 12.4286C36.1929 12.0499 35.5788 12.0499 35.2001 12.4286L34.0573 13.5714L32.9144 12.4286C32.5357 12.0499 31.9217 12.0499 31.543 12.4286C31.1643 12.8073 31.1643 13.4213 31.543 13.8L32.6858 14.9429L31.543 16.0857C31.1643 16.4645 31.1643 17.0785 31.543 17.4572C31.9217 17.8359 32.5357 17.8359 32.9144 17.4572L34.0573 16.3143L35.2002 17.4572C35.5789 17.8359 36.1929 17.8359 36.5716 17.4572C36.9503 17.0785 36.9503 16.4645 36.5716 16.0858L35.4287 14.9429L36.5716 13.8Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_29757_346560"
          x="0"
          y="0"
          width="48"
          height="56.2843"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8.28426" />
          <feGaussianBlur stdDeviation="10.2335" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_29757_346560"
          />
        </filter>
        <filter
          id="filter1_dii_29757_346560"
          x="6.76"
          y="7.13"
          width="34.605"
          height="34.985"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.75" />
          <feGaussianBlur stdDeviation="0.62" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_29757_346560"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_29757_346560"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.87" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.988235 0 0 0 0 0.482353 0 0 0 0 0.0117647 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_29757_346560"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.25" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_29757_346560"
            result="effect3_innerShadow_29757_346560"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const AffiliateIcon = ({ className = "", fillColor = "#333333" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14 11H10C9.46957 11 8.96086 10.7893 8.58579 10.4142C8.21071 10.0391 8 9.53043 8 9C8 8.46957 8.21071 7.96086 8.58579 7.58579C8.96086 7.21071 9.46957 7 10 7H15C15.2652 7 15.5196 7.10536 15.7071 7.29289C15.8946 7.48043 16 7.73478 16 8C16 8.26522 16.1054 8.51957 16.2929 8.70711C16.4804 8.89464 16.7348 9 17 9C17.2652 9 17.5196 8.89464 17.7071 8.70711C17.8946 8.51957 18 8.26522 18 8C18 7.20435 17.6839 6.44129 17.1213 5.87868C16.5587 5.31607 15.7956 5 15 5H13V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2C11.7348 2 11.4804 2.10536 11.2929 2.29289C11.1054 2.48043 11 2.73478 11 3V5H10C8.93913 5 7.92172 5.42143 7.17157 6.17157C6.42143 6.92172 6 7.93913 6 9C6 10.0609 6.42143 11.0783 7.17157 11.8284C7.92172 12.5786 8.93913 13 10 13H14C14.5304 13 15.0391 13.2107 15.4142 13.5858C15.7893 13.9609 16 14.4696 16 15C16 15.5304 15.7893 16.0391 15.4142 16.4142C15.0391 16.7893 14.5304 17 14 17H9C8.73478 17 8.48043 16.8946 8.29289 16.7071C8.10536 16.5196 8 16.2652 8 16C8 15.7348 7.89464 15.4804 7.70711 15.2929C7.51957 15.1054 7.26522 15 7 15C6.73478 15 6.48043 15.1054 6.29289 15.2929C6.10536 15.4804 6 15.7348 6 16C6 16.7956 6.31607 17.5587 6.87868 18.1213C7.44129 18.6839 8.20435 19 9 19H11V21C11 21.2652 11.1054 21.5196 11.2929 21.7071C11.4804 21.8946 11.7348 22 12 22C12.2652 22 12.5196 21.8946 12.7071 21.7071C12.8946 21.5196 13 21.2652 13 21V19H14C15.0609 19 16.0783 18.5786 16.8284 17.8284C17.5786 17.0783 18 16.0609 18 15C18 13.9391 17.5786 12.9217 16.8284 12.1716C16.0783 11.4214 15.0609 11 14 11Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const AffiliateIconV2 = ({
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_6_74650)">
        <rect
          width="24"
          height="24"
          fill="white"
          fillOpacity="0.01"
        />
        <g filter="url(#filter0_i_6_74650)">
          <rect
            width="24"
            height="24"
            fill="#5117B5"
          />
        </g>
        <g filter="url(#filter1_dii_6_74650)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.759 15.9024C18.649 16.0929 18.4053 16.1582 18.2148 16.0482L11.8008 12.3451C11.6102 12.2351 11.5449 11.9914 11.6549 11.8008C11.7649 11.6102 12.0086 11.5449 12.1992 11.655L18.6132 15.3581C18.8038 15.4681 18.8691 15.7118 18.759 15.9024Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter2_dii_6_74650)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.0201 4.46128C14.2327 4.51823 14.3588 4.73671 14.3019 4.94926L12.385 12.1031C12.328 12.3157 12.1095 12.4418 11.897 12.3849C11.6844 12.3279 11.5583 12.1095 11.6153 11.8969L13.5321 4.74302C13.5891 4.53046 13.8076 4.40432 14.0201 4.46128Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter3_dii_6_74650)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.4812 6.48126C6.6368 6.32566 6.88908 6.32566 7.04468 6.48126L12.2817 11.7183C12.4373 11.8739 12.4373 12.1261 12.2817 12.2817C12.1261 12.4373 11.8738 12.4373 11.7182 12.2817L6.4812 7.04474C6.3256 6.88914 6.3256 6.63686 6.4812 6.48126Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter4_dii_6_74650)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.97989 19.5387C9.76733 19.4818 9.64119 19.2633 9.69815 19.0507L11.615 11.8969C11.672 11.6843 11.8905 11.5582 12.103 11.6151C12.3156 11.6721 12.4417 11.8905 12.3847 12.1031L10.4679 19.257C10.4109 19.4695 10.1924 19.5957 9.97989 19.5387Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter5_dii_6_74650)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.19531 12C4.19531 11.7799 4.3737 11.6016 4.59375 11.6016L12 11.6016C12.2201 11.6016 12.3984 11.7799 12.3984 12C12.3984 12.2201 12.2201 12.3984 12 12.3984L4.59375 12.3984C4.3737 12.3984 4.19531 12.2201 4.19531 12Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter6_dii_6_74650)">
          <path
            d="M12.0001 17.4C14.9824 17.4 17.4001 14.9823 17.4001 12C17.4001 9.01764 14.9824 6.59998 12.0001 6.59998C9.01776 6.59998 6.6001 9.01764 6.6001 12C6.6001 14.9823 9.01776 17.4 12.0001 17.4Z"
            fill="#ED7200"
          />
          <path
            d="M17.3848 12C17.3848 14.9739 14.974 17.3847 12.0001 17.3847C9.02621 17.3847 6.61539 14.9739 6.61539 12C6.61539 9.02608 9.02621 6.61527 12.0001 6.61527C14.974 6.61527 17.3848 9.02608 17.3848 12Z"
            stroke="url(#paint0_linear_6_74650)"
            strokeOpacity="0.5"
            strokeWidth="0.0305822"
          />
        </g>
        <g filter="url(#filter7_dii_6_74650)">
          <path
            d="M12.5618 11.4383H11.4385C11.1015 11.4383 10.8769 11.2136 10.8769 10.8767C10.8769 10.5397 11.1016 10.3151 11.4385 10.3151H13.1234C13.4604 10.3151 13.685 10.0904 13.685 9.75347C13.685 9.41649 13.4603 9.19186 13.1234 9.19186H12.5618C12.5618 8.85487 12.3371 8.63025 12.0002 8.63025C11.6632 8.63025 11.4385 8.85492 11.4385 9.19186C10.4838 9.19186 9.75366 9.92197 9.75366 10.8767C9.75366 11.8315 10.4838 12.5616 11.4385 12.5616H12.5618C12.8988 12.5616 13.1234 12.7863 13.1234 13.1232C13.1234 13.4602 12.8988 13.6849 12.5618 13.6849H10.8769C10.5399 13.6849 10.3153 13.9095 10.3153 14.2465C10.3153 14.5835 10.54 14.8081 10.8769 14.8081H11.4385C11.4385 15.1451 11.6632 15.3697 12.0002 15.3697C12.3371 15.3697 12.5618 15.145 12.5618 14.8081C13.5166 14.8081 14.2467 14.078 14.2467 13.1232C14.2467 12.1684 13.5166 11.4383 12.5618 11.4383Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter8_dii_6_74650)">
          <path
            d="M14.4629 3.98047C15.1101 3.98047 15.6348 3.4558 15.6348 2.80859C15.6348 2.16139 15.1101 1.63672 14.4629 1.63672C13.8157 1.63672 13.291 2.16139 13.291 2.80859C13.291 3.4558 13.8157 3.98047 14.4629 3.98047Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter9_dii_6_74650)">
          <path
            d="M6.44336 5.27142C6.44336 4.62421 5.91869 4.09955 5.27148 4.09955C4.62428 4.09955 4.09961 4.62421 4.09961 5.27142C4.09961 5.91863 4.62428 6.4433 5.27148 6.4433C5.91869 6.4433 6.44336 5.91863 6.44336 5.27142Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter10_dii_6_74650)">
          <path
            d="M2.48438 13.1651C3.13158 13.1651 3.65625 12.6404 3.65625 11.9932C3.65625 11.346 3.13158 10.8214 2.48438 10.8214C1.83717 10.8214 1.3125 11.346 1.3125 11.9932C1.3125 12.6404 1.83717 13.1651 2.48438 13.1651Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter11_dii_6_74650)">
          <path
            d="M9.53711 22.3633C10.1843 22.3633 10.709 21.8386 10.709 21.1914C10.709 20.5442 10.1843 20.0195 9.53711 20.0195C8.8899 20.0195 8.36523 20.5442 8.36523 21.1914C8.36523 21.8386 8.8899 22.3633 9.53711 22.3633Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter12_dii_6_74650)">
          <path
            d="M21.4126 16.7578C21.4126 16.1106 20.8879 15.5859 20.2407 15.5859C19.5935 15.5859 19.0688 16.1106 19.0688 16.7578C19.0688 17.405 19.5935 17.9297 20.2407 17.9297C20.8879 17.9297 21.4126 17.405 21.4126 16.7578Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_6_74650"
          x="0"
          y="0"
          width="24"
          height="28.1421"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.14213" />
          <feGaussianBlur stdDeviation="5.11675" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_6_74650"
          />
        </filter>
        <filter
          id="filter1_dii_6_74650"
          x="11.2743"
          y="11.3724"
          width="7.8654"
          height="5.25281"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.196337" />
          <feGaussianBlur stdDeviation="0.163615" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_74650"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_74650"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.22906" />
          <feGaussianBlur stdDeviation="0.261783" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_6_74650"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.0654458" />
          <feGaussianBlur stdDeviation="0.0654458" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_6_74650"
            result="effect3_innerShadow_6_74650"
          />
        </filter>
        <filter
          id="filter2_dii_6_74650"
          x="11.2743"
          y="4.21857"
          width="3.36833"
          height="8.70355"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.196337" />
          <feGaussianBlur stdDeviation="0.163615" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_74650"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_74650"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.22906" />
          <feGaussianBlur stdDeviation="0.261783" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_6_74650"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.0654458" />
          <feGaussianBlur stdDeviation="0.0654458" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_6_74650"
            result="effect3_innerShadow_6_74650"
          />
        </filter>
        <filter
          id="filter3_dii_6_74650"
          x="6.03727"
          y="6.1355"
          width="6.68839"
          height="6.7865"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.196337" />
          <feGaussianBlur stdDeviation="0.163615" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_74650"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_74650"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.22906" />
          <feGaussianBlur stdDeviation="0.261783" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_6_74650"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.0654458" />
          <feGaussianBlur stdDeviation="0.0654458" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_6_74650"
            result="effect3_innerShadow_6_74650"
          />
        </filter>
        <filter
          id="filter4_dii_6_74650"
          x="9.35734"
          y="11.3724"
          width="3.36833"
          height="8.70355"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.196337" />
          <feGaussianBlur stdDeviation="0.163615" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_74650"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_74650"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.22906" />
          <feGaussianBlur stdDeviation="0.261783" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_6_74650"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.0654458" />
          <feGaussianBlur stdDeviation="0.0654458" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_6_74650"
            result="effect3_innerShadow_6_74650"
          />
        </filter>
        <filter
          id="filter5_dii_6_74650"
          x="3.86808"
          y="11.3725"
          width="8.85758"
          height="1.5495"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.196337" />
          <feGaussianBlur stdDeviation="0.163615" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_74650"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_74650"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.22906" />
          <feGaussianBlur stdDeviation="0.261783" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_6_74650"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.0654458" />
          <feGaussianBlur stdDeviation="0.0654458" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_6_74650"
            result="effect3_innerShadow_6_74650"
          />
        </filter>
        <filter
          id="filter6_dii_6_74650"
          x="5.78902"
          y="6.27554"
          width="12.4222"
          height="13.8268"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.48665" />
          <feGaussianBlur stdDeviation="0.405541" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_74650"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_74650"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.70241" />
          <feGaussianBlur stdDeviation="3.33827" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
          />
          <feBlend
            mode="overlay"
            in2="shape"
            result="effect2_innerShadow_6_74650"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.408731" />
          <feGaussianBlur stdDeviation="0.917466" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
          />
          <feBlend
            mode="overlay"
            in2="effect2_innerShadow_6_74650"
            result="effect3_innerShadow_6_74650"
          />
        </filter>
        <filter
          id="filter7_dii_6_74650"
          x="9.07014"
          y="8.15179"
          width="5.85996"
          height="8.31153"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.410111" />
          <feGaussianBlur stdDeviation="0.341759" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_74650"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_74650"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.478463" />
          <feGaussianBlur stdDeviation="0.546815" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.862745 0 0 0 0 0.415686 0 0 0 0 0 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_6_74650"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.136704" />
          <feGaussianBlur stdDeviation="0.136704" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.862745 0 0 0 0 0.415686 0 0 0 0 0 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_6_74650"
            result="effect3_innerShadow_6_74650"
          />
        </filter>
        <filter
          id="filter8_dii_6_74650"
          x="12.9638"
          y="1.40766"
          width="2.99821"
          height="3.09638"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.196337" />
          <feGaussianBlur stdDeviation="0.163615" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_74650"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_74650"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.22906" />
          <feGaussianBlur stdDeviation="0.261783" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_6_74650"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.0654458" />
          <feGaussianBlur stdDeviation="0.0654458" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_6_74650"
            result="effect3_innerShadow_6_74650"
          />
        </filter>
        <filter
          id="filter9_dii_6_74650"
          x="3.77238"
          y="3.87049"
          width="2.99821"
          height="3.09638"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.196337" />
          <feGaussianBlur stdDeviation="0.163615" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_74650"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_74650"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.22906" />
          <feGaussianBlur stdDeviation="0.261783" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_6_74650"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.0654458" />
          <feGaussianBlur stdDeviation="0.0654458" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_6_74650"
            result="effect3_innerShadow_6_74650"
          />
        </filter>
        <filter
          id="filter10_dii_6_74650"
          x="0.985271"
          y="10.5923"
          width="2.99821"
          height="3.09638"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.196337" />
          <feGaussianBlur stdDeviation="0.163615" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_74650"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_74650"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.22906" />
          <feGaussianBlur stdDeviation="0.261783" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_6_74650"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.0654458" />
          <feGaussianBlur stdDeviation="0.0654458" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_6_74650"
            result="effect3_innerShadow_6_74650"
          />
        </filter>
        <filter
          id="filter11_dii_6_74650"
          x="8.03801"
          y="19.7905"
          width="2.99821"
          height="3.09638"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.196337" />
          <feGaussianBlur stdDeviation="0.163615" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_74650"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_74650"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.22906" />
          <feGaussianBlur stdDeviation="0.261783" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_6_74650"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.0654458" />
          <feGaussianBlur stdDeviation="0.0654458" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_6_74650"
            result="effect3_innerShadow_6_74650"
          />
        </filter>
        <filter
          id="filter12_dii_6_74650"
          x="18.7416"
          y="15.3569"
          width="2.99821"
          height="3.09638"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.196337" />
          <feGaussianBlur stdDeviation="0.163615" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6_74650"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6_74650"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.22906" />
          <feGaussianBlur stdDeviation="0.261783" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_6_74650"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.0654458" />
          <feGaussianBlur stdDeviation="0.0654458" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.317647 0 0 0 0 0.0901961 0 0 0 0 0.709804 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_6_74650"
            result="effect3_innerShadow_6_74650"
          />
        </filter>
        <linearGradient
          id="paint0_linear_6_74650"
          x1="12.0001"
          y1="6.59998"
          x2="12.0001"
          y2="17.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop
            offset="1"
            stopColor="white"
            stopOpacity="0"
          />
        </linearGradient>
        <clipPath id="clip0_6_74650">
          <rect
            width="24"
            height="24"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GiftIconV2 = ({ className = "", width = 48, height = 48 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 49 48"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_26566_339148)">
        <g filter="url(#filter0_i_26566_339148)">
          <rect
            x="0.875"
            width="48"
            height="48"
            fill="#FF57B1"
          />
        </g>
        <g filter="url(#filter1_dii_26566_339148)">
          <path
            d="M31.1411 10.0783C31.8709 10.3615 32.5026 10.861 32.9524 11.5343C33.3529 12.1337 33.5707 12.8196 33.6029 13.5141C33.612 13.7102 33.6063 13.907 33.5857 14.1027C33.5335 14.6001 33.3853 15.0906 33.1401 15.5452C32.7348 16.2986 32.1116 16.8813 31.3701 17.2295C31.2642 17.2793 31.1559 17.3242 31.0454 17.3642C30.9936 17.383 30.941 17.4007 30.8879 17.4174C30.6126 17.5039 30.3206 17.5621 30.0218 17.5886C29.9169 17.598 29.8111 17.6034 29.7049 17.6047L24.9849 17.5801L24.967 17.5866L22.2489 17.5714L20.047 17.5733C18.6037 17.586 17.2909 16.7764 16.6094 15.514C15.9461 14.245 16.0219 12.7084 16.8345 11.5169C17.442 10.6034 18.3914 10.015 19.4549 9.85425C19.7023 9.80551 19.9628 9.79266 20.2299 9.798C21.1426 9.84226 21.9717 10.1891 22.619 10.7588C22.6499 10.786 22.6803 10.8136 22.7103 10.8417C23.0102 11.123 23.2678 11.4539 23.4726 11.8259L24.886 14.4343L26.3117 11.8379C26.9539 10.6265 28.1723 9.87943 29.5355 9.81421C30.0126 9.79575 30.476 9.85935 30.9095 9.99681C30.9877 10.0216 31.0649 10.0488 31.1411 10.0783Z"
            fill="#FF9029"
          />
          <path
            d="M33.1252 15.5371L33.1252 15.5372C32.7216 16.2874 32.101 16.8674 31.3629 17.2141C31.2574 17.2636 31.1496 17.3084 31.0396 17.3482C30.988 17.3669 30.9357 17.3846 30.8828 17.4012C30.6087 17.4873 30.3179 17.5453 30.0203 17.5717C29.9158 17.581 29.8105 17.5863 29.7048 17.5877L24.985 17.5631L24.985 17.562L24.9791 17.5641L24.964 17.5696L22.249 17.5544L22.2489 17.5544L20.047 17.5562L20.0469 17.5562C18.6101 17.5689 17.303 16.7631 16.6244 15.506C15.964 14.2425 16.0396 12.7127 16.8486 11.5264L16.8486 11.5264L16.8487 11.5263C17.4535 10.617 18.3986 10.0311 19.4574 9.87108L19.4574 9.8711L19.4582 9.87095C19.7039 9.82254 19.963 9.8097 20.2293 9.81502C21.138 9.85913 21.9634 10.2045 22.6078 10.7716C22.6385 10.7986 22.6688 10.8261 22.6986 10.8541C22.9972 11.1342 23.2537 11.4637 23.4576 11.834C23.4577 11.8341 23.4577 11.8341 23.4577 11.8341L24.871 14.4425L24.8859 14.4699L24.9009 14.4425L26.3266 11.8461L26.3267 11.8459C26.966 10.64 28.1788 9.89618 29.5362 9.83122C30.0113 9.81284 30.4727 9.87619 30.9043 10.013C30.9822 10.0377 31.0591 10.0648 31.1349 10.0942C31.8615 10.3761 32.4904 10.8734 32.9382 11.5438L32.9524 11.5343L32.9382 11.5438C33.337 12.1405 33.5538 12.8234 33.5859 13.5149C33.5949 13.7102 33.5893 13.9061 33.5688 14.1009C33.5168 14.5961 33.3693 15.0845 33.1252 15.5371Z"
            stroke="url(#paint0_linear_26566_339148)"
            strokeOpacity="0.5"
            strokeWidth="0.0340466"
            style={{ mixBlendMode: "overlay" }}
          />
        </g>
        <g filter="url(#filter2_dii_26566_339148)">
          <path
            d="M34.4184 38.2032C36.0101 38.2032 37.2948 36.9183 37.2948 35.3268V20.1584C37.2948 17.9199 37.3105 16.881 37.3073 16.4399C37.3039 15.9696 36.7776 16.5681 36.3542 16.7728L33.8551 17.9808C33.6642 18.0731 33.4416 18.0682 33.2295 18.0682L13.3247 18.0682C12.7877 18.0682 12.3658 18.4901 12.3658 19.027V35.3268C12.3658 36.9183 13.6506 38.2032 15.2423 38.2032L34.4184 38.2032Z"
            fill="#3083FC"
          />
          <path
            d="M37.2714 35.3268C37.2714 36.9054 35.9971 38.1797 34.4184 38.1797L15.2423 38.1797C13.6635 38.1797 12.3893 36.9054 12.3893 35.3268V19.027C12.3893 18.503 12.8006 18.0917 13.3247 18.0917L33.2295 18.0917C33.2401 18.0917 33.2508 18.0917 33.2615 18.0917C33.4629 18.092 33.6785 18.0922 33.8653 18.0019L36.3644 16.7939C36.4722 16.7418 36.5858 16.6649 36.6948 16.5874C36.724 16.5666 36.7528 16.5458 36.7811 16.5254C36.8592 16.469 36.9334 16.4155 37.0007 16.3731C37.0465 16.3443 37.0881 16.3212 37.1248 16.3063C37.1618 16.2912 37.1913 16.2853 37.2137 16.288C37.2343 16.2905 37.2503 16.3003 37.2622 16.3221C37.275 16.3454 37.2835 16.3829 37.2839 16.4401C37.2852 16.614 37.2835 16.8808 37.281 17.2774C37.2772 17.8865 37.2714 18.8021 37.2714 20.1584V35.3268Z"
            stroke="url(#paint1_linear_26566_339148)"
            strokeOpacity="0.5"
            strokeWidth="0.046875"
            style={{ mixBlendMode: "overlay" }}
          />
        </g>
        <g filter="url(#filter3_dii_26566_339148)">
          <path
            d="M10.4844 15.0342C10.4844 14.2222 11.1426 13.564 11.9546 13.564H37.8423C38.6543 13.564 39.3125 14.2222 39.3125 15.0342V20.7991C39.3125 21.0748 39.089 21.2983 38.8133 21.2983H10.9836C10.7079 21.2983 10.4844 21.0748 10.4844 20.7991V15.0342Z"
            fill="#3083FC"
          />
          <path
            d="M10.5078 15.0342C10.5078 14.2352 11.1556 13.5874 11.9546 13.5874H37.8423C38.6413 13.5874 39.2891 14.2352 39.2891 15.0342V20.7991C39.2891 21.0619 39.076 21.2749 38.8133 21.2749H10.9836C10.7208 21.2749 10.5078 21.0619 10.5078 20.7991V15.0342Z"
            stroke="url(#paint2_linear_26566_339148)"
            strokeOpacity="0.5"
            strokeWidth="0.046875"
            style={{ mixBlendMode: "overlay" }}
          />
        </g>
        <g filter="url(#filter4_dii_26566_339148)">
          <path
            d="M24.7256 33.5768C24.7774 33.6297 24.8479 33.659 24.9217 33.659C24.9955 33.659 25.066 33.6297 25.1178 33.5768L28.6414 30.0065C30.1109 28.5179 29.0667 25.9463 26.977 25.9463C25.722 25.9463 25.1461 26.8685 24.9217 27.0408C24.6962 26.8678 24.124 25.9463 22.8664 25.9463C20.7833 25.9463 19.7262 28.5113 21.2023 30.0065L24.7256 33.5768Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_26566_339148"
          x="0.875"
          y="0"
          width="48"
          height="52.1421"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.14213" />
          <feGaussianBlur stdDeviation="5.11675" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 0.820333 0 0 0 0 0.358333 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_26566_339148"
          />
        </filter>
        <filter
          id="filter1_dii_26566_339148"
          x="15.2598"
          y="9.43569"
          width="19.2503"
          height="11.1773"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.541778" />
          <feGaussianBlur stdDeviation="0.451481" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_26566_339148"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_26566_339148"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.00854" />
          <feGaussianBlur stdDeviation="3.71644" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
          />
          <feBlend
            mode="overlay"
            in2="shape"
            result="effect2_innerShadow_26566_339148"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.689297" />
          <feGaussianBlur stdDeviation="0.669844" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
          />
          <feBlend
            mode="overlay"
            in2="effect2_innerShadow_26566_339148"
            result="effect3_innerShadow_26566_339148"
          />
        </filter>
        <filter
          id="filter2_dii_26566_339148"
          x="11.4629"
          y="14.3988"
          width="26.7478"
          height="26.8129"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.541778" />
          <feGaussianBlur stdDeviation="0.451481" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_26566_339148"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_26566_339148"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.00854" />
          <feGaussianBlur stdDeviation="3.71644" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
          />
          <feBlend
            mode="overlay"
            in2="shape"
            result="effect2_innerShadow_26566_339148"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-1.86539" />
          <feGaussianBlur stdDeviation="1.0214" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
          />
          <feBlend
            mode="overlay"
            in2="effect2_innerShadow_26566_339148"
            result="effect3_innerShadow_26566_339148"
          />
        </filter>
        <filter
          id="filter3_dii_26566_339148"
          x="9.58141"
          y="13.2028"
          width="30.6341"
          height="11.1041"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.541778" />
          <feGaussianBlur stdDeviation="0.451481" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_26566_339148"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_26566_339148"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.00854" />
          <feGaussianBlur stdDeviation="3.71644" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
          />
          <feBlend
            mode="overlay"
            in2="shape"
            result="effect2_innerShadow_26566_339148"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.455033" />
          <feGaussianBlur stdDeviation="1.0214" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
          />
          <feBlend
            mode="overlay"
            in2="effect2_innerShadow_26566_339148"
            result="effect3_innerShadow_26566_339148"
          />
        </filter>
        <filter
          id="filter4_dii_26566_339148"
          x="20.1151"
          y="25.5166"
          width="9.61195"
          height="8.78086"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.23936" />
          <feGaussianBlur stdDeviation="0.199466" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_26566_339148"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_26566_339148"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.429672" />
          <feGaussianBlur stdDeviation="0.657595" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.262745 0 0 0 0 0.533333 0 0 0 0 0.929412 0 0 0 0.55 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_26566_339148"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.0797865" />
          <feGaussianBlur stdDeviation="0.0797865" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_26566_339148"
            result="effect3_innerShadow_26566_339148"
          />
        </filter>
        <linearGradient
          id="paint0_linear_26566_339148"
          x1="24.8849"
          y1="9.79688"
          x2="24.8849"
          y2="17.6047"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop
            offset="1"
            stopColor="white"
            stopOpacity="0"
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear_26566_339148"
          x1="24.8303"
          y1="20.8807"
          x2="24.8303"
          y2="38.2032"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop
            offset="1"
            stopColor="white"
            stopOpacity="0"
          />
        </linearGradient>
        <linearGradient
          id="paint2_linear_26566_339148"
          x1="24.8984"
          y1="13.564"
          x2="24.8984"
          y2="21.2983"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop
            offset="1"
            stopColor="white"
            stopOpacity="0"
          />
        </linearGradient>
        <clipPath id="clip0_26566_339148">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.875)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const GiftIcon = ({ className = "", fillColor = "#333333" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M18 7.00004H17.65C17.8782 6.5328 17.9979 6.02002 18 5.50004C18.003 4.80336 17.7975 4.12173 17.4098 3.54287C17.0221 2.96401 16.4701 2.51442 15.8247 2.25198C15.1794 1.98953 14.4703 1.92624 13.7886 2.07025C13.107 2.21426 12.4841 2.55898 12 3.06004C11.5159 2.55898 10.893 2.21426 10.2114 2.07025C9.52975 1.92624 8.82061 1.98953 8.17525 2.25198C7.5299 2.51442 6.97786 2.96401 6.59019 3.54287C6.20252 4.12173 5.99697 4.80336 6 5.50004C6.00213 6.02002 6.12178 6.5328 6.35 7.00004H6C5.20435 7.00004 4.44129 7.31611 3.87868 7.87872C3.31607 8.44133 3 9.20439 3 10V12C3 12.2653 3.10536 12.5196 3.29289 12.7071C3.48043 12.8947 3.73478 13 4 13H5V19C5 19.7957 5.31607 20.5588 5.87868 21.1214C6.44129 21.684 7.20435 22 8 22H16C16.7956 22 17.5587 21.684 18.1213 21.1214C18.6839 20.5588 19 19.7957 19 19V13H20C20.2652 13 20.5196 12.8947 20.7071 12.7071C20.8946 12.5196 21 12.2653 21 12V10C21 9.20439 20.6839 8.44133 20.1213 7.87872C19.5587 7.31611 18.7956 7.00004 18 7.00004ZM11 20H8C7.73478 20 7.48043 19.8947 7.29289 19.7071C7.10536 19.5196 7 19.2653 7 19V13H11V20ZM11 11H5V10C5 9.73482 5.10536 9.48047 5.29289 9.29293C5.48043 9.10539 5.73478 9.00004 6 9.00004H11V11ZM11 7.00004H9.5C9.20333 7.00004 8.91332 6.91206 8.66665 6.74724C8.41997 6.58242 8.22771 6.34815 8.11418 6.07406C8.00065 5.79997 7.97094 5.49837 8.02882 5.2074C8.0867 4.91643 8.22956 4.64916 8.43934 4.43938C8.64912 4.2296 8.91639 4.08674 9.20736 4.02886C9.49834 3.97098 9.79994 4.00069 10.074 4.11422C10.3481 4.22775 10.5824 4.42001 10.7472 4.66668C10.912 4.91336 11 5.20337 11 5.50004V7.00004ZM13 5.50004C13 5.20337 13.088 4.91336 13.2528 4.66668C13.4176 4.42001 13.6519 4.22775 13.926 4.11422C14.2001 4.00069 14.5017 3.97098 14.7926 4.02886C15.0836 4.08674 15.3509 4.2296 15.5607 4.43938C15.7704 4.64916 15.9133 4.91643 15.9712 5.2074C16.0291 5.49837 15.9994 5.79997 15.8858 6.07406C15.7723 6.34815 15.58 6.58242 15.3334 6.74724C15.0867 6.91206 14.7967 7.00004 14.5 7.00004H13V5.50004ZM17 19C17 19.2653 16.8946 19.5196 16.7071 19.7071C16.5196 19.8947 16.2652 20 16 20H13V13H17V19ZM19 11H13V9.00004H18C18.2652 9.00004 18.5196 9.10539 18.7071 9.29293C18.8946 9.48047 19 9.73482 19 10V11Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const DigitalProductIcon = ({
  className = "",
  fillColor = "#333333",
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7 14H9C9.26522 14 9.51957 13.8946 9.70711 13.7071C9.89464 13.5196 10 13.2652 10 13C10 12.7348 9.89464 12.4804 9.70711 12.2929C9.51957 12.1054 9.26522 12 9 12H7C6.73478 12 6.48043 12.1054 6.29289 12.2929C6.10536 12.4804 6 12.7348 6 13C6 13.2652 6.10536 13.5196 6.29289 13.7071C6.48043 13.8946 6.73478 14 7 14ZM13 16H7C6.73478 16 6.48043 16.1054 6.29289 16.2929C6.10536 16.4804 6 16.7348 6 17C6 17.2652 6.10536 17.5196 6.29289 17.7071C6.48043 17.8946 6.73478 18 7 18H13C13.2652 18 13.5196 17.8946 13.7071 17.7071C13.8946 17.5196 14 17.2652 14 17C14 16.7348 13.8946 16.4804 13.7071 16.2929C13.5196 16.1054 13.2652 16 13 16ZM19 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V5C22 4.20435 21.6839 3.44129 21.1213 2.87868C20.5587 2.31607 19.7956 2 19 2ZM14 4V7.29L12.49 6.45C12.338 6.36223 12.1655 6.31603 11.99 6.31603C11.8145 6.31603 11.642 6.36223 11.49 6.45L10 7.29V4H14ZM20 19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H8V9C8.00105 9.17451 8.04776 9.34571 8.13547 9.49658C8.22319 9.64746 8.34886 9.77274 8.5 9.86C8.65202 9.94777 8.82446 9.99397 9 9.99397C9.17554 9.99397 9.34798 9.94777 9.5 9.86L12 8.47L14.51 9.87C14.6595 9.9547 14.8282 9.99947 15 10C15.2652 10 15.5196 9.89464 15.7071 9.70711C15.8946 9.51957 16 9.26522 16 9V4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5V19Z"
        fill={fillColor}
      />
    </svg>
  );
};
export const DigitalProducticonV2 = ({ className = "", width = 48, height = 48 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_26663_338318)">
        <g filter="url(#filter0_i_26663_338318)">
          <rect
            width="48"
            height="48"
            fill="#5117B5"
          />
        </g>
        <g filter="url(#filter1_dii_26663_338318)">
          <path
            d="M38.9381 20.0156H38.0515C37.0741 20.0156 36.2818 19.2233 36.2818 18.2459V17.3594C36.2821 17.0977 36.2309 16.8385 36.1309 16.5966C36.0309 16.3547 35.8841 16.135 35.6991 15.9499C35.514 15.7649 35.2943 15.6181 35.0524 15.5181C34.8105 15.4181 34.5513 15.3668 34.2896 15.3672H24.1626C23.8661 15.3673 23.5733 15.3011 23.3057 15.1736C23.038 15.0461 22.8021 14.8604 22.6154 14.6301L21.3138 13.0297C21.0657 12.7227 20.7521 12.4751 20.3959 12.3051C20.0397 12.135 19.6499 12.0468 19.2552 12.0469H11.7115C11.4497 12.0465 11.1905 12.0978 10.9487 12.1978C10.7068 12.2978 10.487 12.4445 10.302 12.6296C10.1169 12.8147 9.97019 13.0344 9.8702 13.2763C9.7702 13.5181 9.71891 13.7774 9.71926 14.0391V33.6754C9.71789 33.9745 9.77654 34.2709 9.89175 34.5469C10.007 34.823 10.1764 35.0731 10.39 35.2825C10.5994 35.4961 10.8495 35.6655 11.1255 35.7807C11.4015 35.8959 11.6979 35.9545 11.997 35.9532H34.3494C34.8428 35.953 35.3229 35.7931 35.7179 35.4975C36.1129 35.2018 36.4016 34.7863 36.5408 34.3129L40.2131 21.7156C40.2704 21.5177 40.2809 21.3092 40.2438 21.1065C40.2068 20.9038 40.1231 20.7125 39.9995 20.5477C39.8759 20.3828 39.7156 20.249 39.5314 20.1567C39.3472 20.0643 39.1441 20.016 38.9381 20.0156Z"
            fill="#ED7200"
          />
          <path
            d="M21.3006 13.0404L21.3006 13.0404L22.6022 14.6408C22.7905 14.8731 23.0284 15.0603 23.2983 15.189C23.5683 15.3176 23.8636 15.3843 24.1626 15.3842H34.2896C34.5491 15.3839 34.8061 15.4347 35.0459 15.5339C35.2857 15.633 35.5036 15.7785 35.687 15.962C35.8705 16.1454 36.016 16.3633 36.1151 16.6031C36.2143 16.8429 36.2651 17.0999 36.2648 17.3594V18.2459C36.2648 19.2327 37.0647 20.0327 38.0515 20.0327H38.938C39.1414 20.0331 39.342 20.0807 39.5238 20.1719C39.7056 20.263 39.8638 20.3952 39.9859 20.5579C40.1079 20.7206 40.1905 20.9095 40.2271 21.1096C40.2637 21.3097 40.2533 21.5155 40.1967 21.7109L36.5245 34.3081C36.3863 34.7779 36.0997 35.1904 35.7077 35.4839C35.3156 35.7773 34.8391 35.936 34.3494 35.9361H11.997H11.9969C11.7001 35.9375 11.406 35.8793 11.1321 35.765C10.8581 35.6506 10.6099 35.4825 10.4021 35.2705L10.4019 35.2703C10.1899 35.0625 10.0218 34.8143 9.90746 34.5404C9.79313 34.2664 9.73492 33.9723 9.73629 33.6755V33.6754L9.73629 14.0391L9.73629 14.039C9.73594 13.7796 9.78679 13.5226 9.88593 13.2828C9.98507 13.043 10.1305 12.8251 10.314 12.6416C10.4975 12.4582 10.7154 12.3127 10.9552 12.2135C11.195 12.1144 11.452 12.0636 11.7114 12.0639H11.7115L19.2552 12.0639C19.6474 12.0638 20.0346 12.1514 20.3885 12.3204C20.7424 12.4894 21.0541 12.7354 21.3006 13.0404Z"
            stroke="url(#paint0_linear_26663_338318)"
            strokeOpacity="0.5"
            strokeWidth="0.0340466"
            style={{ mixBlendMode: "overlay" }}
          />
        </g>
        <g filter="url(#filter2_dii_26663_338318)">
          <path
            d="M38.9372 20.0156H20.0604C19.5676 20.0157 19.0881 20.1756 18.6938 20.4713C18.2996 20.7671 18.0119 21.1827 17.874 21.6559L14.1818 34.3138C14.0439 34.7868 13.7563 35.2022 13.3622 35.4978C12.9681 35.7933 12.4887 35.9531 11.9961 35.9531H34.351C34.8439 35.9532 35.3236 35.7933 35.7179 35.4976C36.1122 35.2018 36.4 34.7861 36.538 34.3129L40.2123 21.7156C40.27 21.5177 40.2809 21.309 40.244 21.1062C40.2071 20.9033 40.1235 20.7118 39.9998 20.5468C39.876 20.3819 39.7156 20.248 39.5312 20.1558C39.3468 20.0636 39.1434 20.0156 38.9372 20.0156Z"
            fill="#FF8413"
          />
          <path
            d="M12.3898 35.9361C12.7444 35.8743 13.0815 35.7296 13.3724 35.5114C13.7694 35.2136 14.0592 34.7951 14.1981 34.3186L17.8903 21.6606L17.874 21.6559L17.8903 21.6606C18.0272 21.191 18.3128 20.7785 18.704 20.485C19.0953 20.1914 19.5713 20.0327 20.0604 20.0326H38.9372C39.1408 20.0326 39.3415 20.08 39.5236 20.171C39.7056 20.2621 39.864 20.3942 39.9861 20.5571C40.1083 20.7199 40.1908 20.9089 40.2272 21.1092C40.2636 21.3095 40.2529 21.5155 40.1959 21.7109L36.5216 34.3081L36.538 34.3129L36.5216 34.3081C36.3847 34.7778 36.0991 35.1904 35.7077 35.484C35.3163 35.7775 34.8402 35.9362 34.351 35.9361H12.3898Z"
            stroke="url(#paint1_linear_26663_338318)"
            strokeOpacity="0.5"
            strokeWidth="0.0340466"
            style={{ mixBlendMode: "overlay" }}
          />
        </g>
        <g filter="url(#filter3_dii_26663_338318)">
          <path
            d="M26.521 24.4519C26.6321 24.0585 27.0476 23.8603 27.2689 24.0952L31.4056 28.4853C31.6269 28.7202 31.488 29.2119 31.1557 29.3704L24.9424 32.334C24.61 32.4925 24.3334 32.199 24.4445 31.8056L26.521 24.4519Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_26663_338318"
          x="0"
          y="0"
          width="48"
          height="52.1421"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.14213" />
          <feGaussianBlur stdDeviation="5.11675" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_26663_338318"
          />
        </filter>
        <filter
          id="filter1_dii_26663_338318"
          x="8.81628"
          y="11.6857"
          width="32.3523"
          height="27.276"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.541778" />
          <feGaussianBlur stdDeviation="0.451481" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_26663_338318"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_26663_338318"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.00854" />
          <feGaussianBlur stdDeviation="3.71644" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
          />
          <feBlend
            mode="overlay"
            in2="shape"
            result="effect2_innerShadow_26663_338318"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.455033" />
          <feGaussianBlur stdDeviation="1.0214" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
          />
          <feBlend
            mode="overlay"
            in2="effect2_innerShadow_26663_338318"
            result="effect3_innerShadow_26663_338318"
          />
        </filter>
        <filter
          id="filter2_dii_26663_338318"
          x="11.0931"
          y="19.6544"
          width="30.0755"
          height="19.3072"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.541778" />
          <feGaussianBlur stdDeviation="0.451481" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_26663_338318"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_26663_338318"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.00854" />
          <feGaussianBlur stdDeviation="3.71644" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
          />
          <feBlend
            mode="overlay"
            in2="shape"
            result="effect2_innerShadow_26663_338318"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.455033" />
          <feGaussianBlur stdDeviation="1.0214" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
          />
          <feBlend
            mode="overlay"
            in2="effect2_innerShadow_26663_338318"
            result="effect3_innerShadow_26663_338318"
          />
        </filter>
        <filter
          id="filter3_dii_26663_338318"
          x="23.9121"
          y="23.639"
          width="8.10835"
          height="9.55058"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.304379" />
          <feGaussianBlur stdDeviation="0.253649" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_26663_338318"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_26663_338318"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.355109" />
          <feGaussianBlur stdDeviation="0.405839" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.929412 0 0 0 0 0.447059 0 0 0 0 0 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_26663_338318"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.10146" />
          <feGaussianBlur stdDeviation="0.10146" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_26663_338318"
            result="effect3_innerShadow_26663_338318"
          />
        </filter>
        <linearGradient
          id="paint0_linear_26663_338318"
          x1="24.9924"
          y1="12.0469"
          x2="24.9924"
          y2="35.9532"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop
            offset="1"
            stopColor="white"
            stopOpacity="0"
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear_26663_338318"
          x1="26.1308"
          y1="20.0156"
          x2="26.1308"
          y2="35.9531"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop
            offset="1"
            stopColor="white"
            stopOpacity="0"
          />
        </linearGradient>
        <clipPath id="clip0_26663_338318">
          <rect
            width="48"
            height="48"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BioIcon = ({ className = "", fillColor = "#333333" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12 2C10.0605 2.00369 8.16387 2.57131 6.54122 3.63374C4.91856 4.69617 3.63988 6.20754 2.86093 7.98377C2.08197 9.76 1.83636 11.7244 2.15401 13.6378C2.47166 15.5511 3.33887 17.3308 4.64999 18.76C5.58641 19.775 6.72293 20.5851 7.98793 21.1392C9.25292 21.6933 10.619 21.9793 12 21.9793C13.381 21.9793 14.7471 21.6933 16.012 21.1392C17.277 20.5851 18.4136 19.775 19.35 18.76C20.6611 17.3308 21.5283 15.5511 21.846 13.6378C22.1636 11.7244 21.918 9.76 21.139 7.98377C20.3601 6.20754 19.0814 4.69617 17.4588 3.63374C15.8361 2.57131 13.9395 2.00369 12 2ZM12 20C9.92845 19.9969 7.9389 19.1903 6.44999 17.75C6.90203 16.6495 7.67102 15.7083 8.65924 15.0459C9.64746 14.3835 10.8103 14.0298 12 14.0298C13.1897 14.0298 14.3525 14.3835 15.3407 15.0459C16.329 15.7083 17.0979 16.6495 17.55 17.75C16.0611 19.1903 14.0715 19.9969 12 20ZM9.99999 10C9.99999 9.60444 10.1173 9.21776 10.337 8.88886C10.5568 8.55996 10.8692 8.30362 11.2346 8.15224C11.6001 8.00087 12.0022 7.96126 12.3902 8.03843C12.7781 8.1156 13.1345 8.30608 13.4142 8.58579C13.6939 8.86549 13.8844 9.22186 13.9616 9.60982C14.0387 9.99778 13.9991 10.3999 13.8477 10.7654C13.6964 11.1308 13.44 11.4432 13.1111 11.6629C12.7822 11.8827 12.3955 12 12 12C11.4696 12 10.9608 11.7893 10.5858 11.4142C10.2107 11.0391 9.99999 10.5304 9.99999 10ZM18.91 16C18.0165 14.4718 16.6414 13.283 15 12.62C15.5092 12.0427 15.8409 11.3307 15.9555 10.5694C16.07 9.80822 15.9625 9.03011 15.6457 8.3285C15.329 7.62688 14.8166 7.03156 14.1699 6.61397C13.5232 6.19637 12.7698 5.97425 12 5.97425C11.2302 5.97425 10.4768 6.19637 9.83008 6.61397C9.1834 7.03156 8.67096 7.62688 8.35424 8.3285C8.03752 9.03011 7.92997 9.80822 8.04452 10.5694C8.15906 11.3307 8.49082 12.0427 8.99999 12.62C7.35859 13.283 5.98346 14.4718 5.08999 16C4.37793 14.7871 4.00171 13.4065 3.99999 12C3.99999 9.87827 4.84284 7.84344 6.34313 6.34315C7.84342 4.84285 9.87826 4 12 4C14.1217 4 16.1566 4.84285 17.6568 6.34315C19.1571 7.84344 20 9.87827 20 12C19.9983 13.4065 19.622 14.7871 18.91 16Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const IconBrandGift = (props) => {
  return (
    <img
      {...props}
      src={
        "https://i.ecomobi.com/ssp/mini-store/brand-gift/icon-brand-gift.png"
      }
    />
  );
};
export const IconBrandRating = (props) => {
  return (
    <img
      {...props}
      src={
        "https://i.ecomobi.com/ssp/mini-store/brand-deal/brandRatingDetails.png"
      }
    />
  );
};

export const TruthOrDareIcon = (props) => {
  return (
    <svg
      width={33}
      height={32}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2_31)">
        <g filter="url(#filter0_i_2_31)">
          <rect
            x={0.5}
            width={32}
            height={32}
            fill="#FA6B22"
          />
        </g>
        <g filter="url(#filter1_dii_2_31)">
          <path
            d="M11.1697 12.6978L11.1697 12.6978L11.1701 12.6984C11.2476 12.8032 11.2745 12.9925 11.2442 13.273L11.1226 14.3995C11.0979 14.6283 11.0865 14.7881 11.0889 14.8779C11.0905 14.9377 11.0971 14.9999 11.1087 15.0646C11.1212 15.1349 11.1823 15.1797 11.2541 15.1797H11.9163C12.0406 15.1797 12.1326 15.0531 12.1196 14.939C12.1157 14.905 12.1137 14.871 12.1136 14.8371C12.1138 14.7268 12.1233 14.5839 12.1423 14.4083L12.2591 13.3258C12.2985 12.9604 12.28 12.6663 12.2016 12.445C12.1322 12.233 11.9894 12.0886 11.7746 12.0127C12.2085 11.8296 12.4561 11.4183 12.5238 10.7911L12.5647 10.4127C12.6169 9.92846 12.5402 9.56634 12.3294 9.33141C12.119 9.09041 11.7584 8.97245 11.2538 8.97245H9.95746C9.86357 8.97245 9.77928 9.04812 9.76921 9.14147L9.13575 15.0107C9.12568 15.104 9.19363 15.1797 9.28752 15.1797H9.9681C10.062 15.1797 10.1463 15.104 10.1564 15.0107L10.4099 12.6618C10.4172 12.5942 10.4782 12.5394 10.5462 12.5394H10.736C10.9572 12.5394 11.0988 12.5945 11.1697 12.6978ZM11.2863 11.4699L11.2863 11.4699L11.2858 11.4704C11.1873 11.5638 11.0447 11.6127 10.8537 11.6127H10.6462C10.5782 11.6127 10.529 11.5579 10.5363 11.4903L10.6948 10.0216C10.7021 9.95396 10.7632 9.89915 10.8312 9.89915H11.1272C11.2938 9.89915 11.4043 9.94753 11.4652 10.0396L11.4652 10.0396L11.4657 10.0403C11.533 10.1337 11.5575 10.2884 11.5336 10.5095L11.4823 10.9848C11.4572 11.2172 11.3902 11.3767 11.2863 11.4699ZM13.6091 14.8641L13.6093 14.8643C13.8336 15.1343 14.1863 15.2677 14.6628 15.2677C15.1394 15.2677 15.5208 15.1343 15.8034 14.8643L15.8036 14.8641C16.0864 14.5885 16.2535 14.1978 16.3077 13.6954L16.7992 9.14147C16.8093 9.04812 16.7413 8.97245 16.6474 8.97245H16.0022C15.9084 8.97245 15.8241 9.04812 15.814 9.14147L15.3149 13.7659C15.2923 13.9747 15.2327 14.1201 15.1408 14.2076L15.1402 14.2082C15.0537 14.2957 14.9351 14.341 14.7805 14.341C14.6262 14.341 14.5141 14.2958 14.4405 14.2079C14.3731 14.1203 14.3478 13.9748 14.3703 13.7659L14.8694 9.14147C14.8795 9.04812 14.8116 8.97245 14.7177 8.97245H14.0371C13.9432 8.97245 13.8589 9.04812 13.8488 9.14147L13.3573 13.6954C13.3031 14.1978 13.3858 14.5885 13.6091 14.8641ZM5.83148 9.89915H6.55632C6.62433 9.89915 6.67354 9.95396 6.66624 10.0216L6.12778 15.0107C6.1177 15.104 6.18565 15.1797 6.27954 15.1797H6.96013C7.05402 15.1797 7.1383 15.104 7.14838 15.0107L7.68684 10.0216C7.69414 9.95396 7.75519 9.89915 7.82319 9.89915H8.54803C8.64193 9.89915 8.72621 9.82347 8.73628 9.73012L8.79982 9.14147C8.80989 9.04812 8.74194 8.97245 8.64805 8.97245H5.9315C5.8376 8.97245 5.75332 9.04812 5.74324 9.14148L5.67971 9.73012C5.66964 9.82347 5.73759 9.89915 5.83148 9.89915ZM17.8222 9.89915H18.547C18.615 9.89915 18.6642 9.95396 18.6569 10.0216L18.1185 15.0107C18.1084 15.104 18.1763 15.1797 18.2702 15.1797H18.9508C19.0447 15.1797 19.129 15.104 19.1391 15.0107L19.6775 10.0216C19.6848 9.95396 19.7459 9.89915 19.8139 9.89915H20.5387C20.6326 9.89915 20.7169 9.82347 20.727 9.73012L20.7905 9.14147C20.8006 9.04812 20.7326 8.97245 20.6387 8.97245H17.9222C17.8283 8.97245 17.744 9.04812 17.7339 9.14148L17.6704 9.73012C17.6603 9.82347 17.7283 9.89915 17.8222 9.89915ZM22.6287 8.97245H21.9481C21.8543 8.97245 21.77 9.04812 21.7599 9.14147L21.1264 15.0107C21.1164 15.104 21.1843 15.1797 21.2782 15.1797H21.9588C22.0527 15.1797 22.137 15.104 22.147 15.0107L22.4148 12.5298C22.4221 12.4622 22.4831 12.4074 22.5511 12.4074H23.3025C23.3705 12.4074 23.4198 12.4622 23.4125 12.5298L23.1447 15.0107C23.1346 15.104 23.2026 15.1797 23.2965 15.1797H23.9771C24.071 15.1797 24.1552 15.104 24.1653 15.0107L24.7988 9.14147C24.8088 9.04812 24.7409 8.97245 24.647 8.97245H23.9664C23.8725 8.97245 23.7882 9.04812 23.7782 9.14148L23.5389 11.3583C23.5316 11.4259 23.4706 11.4807 23.4026 11.4807H22.6512C22.5832 11.4807 22.5339 11.4259 22.5412 11.3583L22.7805 9.14147C22.7906 9.04812 22.7226 8.97245 22.6287 8.97245Z"
            fill="white"
            stroke="white"
            strokeWidth={0.046875}
          />
          <g filter="url(#filter2_d_2_31)">
            <path
              d="M6.13358 21.6328C5.77716 21.6328 5.51603 21.5323 5.35019 21.3312C5.18435 21.1302 5.12276 20.8461 5.16544 20.4789L5.44588 18.0662C5.48855 17.6991 5.61618 17.415 5.82876 17.2139C6.04135 17.0129 6.32585 16.9123 6.68227 16.9123C7.03869 16.9123 7.29982 17.0129 7.46566 17.2139C7.6315 17.415 7.69309 17.6991 7.65041 18.0662L7.36997 20.4789C7.3273 20.8461 7.19967 21.1302 6.98709 21.3312C6.77451 21.5323 6.49 21.6328 6.13358 21.6328ZM6.20979 20.9772C6.4606 20.9772 6.60354 20.8264 6.63859 20.5248L6.9297 18.0203C6.96476 17.7187 6.85688 17.568 6.60606 17.568C6.35525 17.568 6.21231 17.7187 6.17726 18.0203L5.88615 20.5248C5.85109 20.8264 5.95897 20.9772 6.20979 20.9772Z"
              fill="white"
            />
            <path
              d="M8.79583 17.1235C8.80517 17.0431 8.87837 16.9779 8.95932 16.9779H9.88861C10.2626 16.9779 10.5253 17.0653 10.6766 17.2401C10.8284 17.4106 10.8834 17.675 10.8418 18.0334L10.809 18.3154C10.754 18.7888 10.5626 19.0896 10.2347 19.2178C10.2311 19.2192 10.2283 19.2226 10.2279 19.2264V19.2264C10.2274 19.2304 10.2297 19.234 10.2335 19.2353C10.3998 19.2884 10.5084 19.3948 10.5594 19.5545C10.6154 19.7162 10.6276 19.9326 10.5961 20.2036L10.5024 21.01C10.4872 21.1411 10.4791 21.2482 10.4783 21.3312C10.4782 21.3385 10.4783 21.3457 10.4785 21.353C10.4813 21.4573 10.3974 21.5673 10.2913 21.5673H9.8813C9.81915 21.5673 9.76724 21.5286 9.75854 21.4688C9.75294 21.4304 9.74982 21.3933 9.74918 21.3575C9.748 21.2919 9.75731 21.1739 9.77713 21.0034L9.87467 20.1642C9.89906 19.9544 9.88088 19.808 9.82012 19.725C9.76377 19.6419 9.65199 19.6004 9.48478 19.6004H9.38054C9.29959 19.6004 9.22639 19.6656 9.21704 19.746L9.02227 21.4217C9.01292 21.5021 8.93973 21.5673 8.85878 21.5673H8.42587C8.34493 21.5673 8.28688 21.5021 8.29623 21.4217L8.79583 17.1235ZM9.57419 18.9448C9.7194 18.9448 9.83152 18.9076 9.91056 18.8333C9.99401 18.759 10.0459 18.6344 10.0662 18.4596L10.1074 18.1056C10.1267 17.9395 10.1098 17.8193 10.0569 17.745C10.0083 17.6707 9.92021 17.6335 9.79261 17.6335H9.60916C9.52821 17.6335 9.45501 17.6987 9.44566 17.7791L9.3271 18.7992C9.31775 18.8796 9.3758 18.9448 9.45674 18.9448H9.57419Z"
              fill="white"
            />
            <path
              d="M9.80005 19.7394L9.80004 19.7394L9.80045 19.74C9.85634 19.8164 9.8755 19.9555 9.85123 20.1642L9.75369 21.0034C9.73389 21.1738 9.72438 21.2933 9.72559 21.3605C9.72625 21.3974 9.72946 21.4354 9.73517 21.4747C9.74553 21.5459 9.80704 21.5906 9.87859 21.5906H10.2886C10.3505 21.5906 10.4051 21.5583 10.4432 21.5128C10.4811 21.4675 10.5036 21.4079 10.5021 21.3497C10.5019 21.3427 10.5018 21.3358 10.5019 21.3288C10.5027 21.2469 10.5107 21.1407 10.5258 21.01L10.6196 20.2036C10.6513 19.9309 10.6393 19.7109 10.5819 19.545C10.5323 19.39 10.43 19.283 10.2764 19.2247C10.5954 19.0841 10.7788 18.777 10.8325 18.3154L10.8652 18.0334C10.9072 17.6719 10.8523 17.4003 10.6952 17.2238C10.5383 17.0426 10.2683 16.9546 9.89132 16.9546H8.96203C8.86813 16.9546 8.78323 17.0302 8.77239 17.1235L8.27279 21.4217C8.26195 21.5149 8.32928 21.5906 8.42317 21.5906H8.85607C8.94996 21.5906 9.03487 21.5149 9.04571 21.4217L9.24048 19.746C9.24833 19.6784 9.30983 19.6237 9.37783 19.6237H9.48208C9.64623 19.6237 9.74924 19.6645 9.80005 19.7394ZM9.8959 18.8168L9.8959 18.8168L9.89535 18.8174C9.82305 18.8853 9.71837 18.9215 9.5769 18.9215H9.45945C9.39145 18.9215 9.34268 18.8667 9.35053 18.7992L9.4691 17.7791C9.47695 17.7116 9.53845 17.6568 9.60645 17.6568H9.7899C9.91299 17.6568 9.99304 17.6925 10.0366 17.7591L10.0366 17.7591L10.0371 17.7598C10.0856 17.8278 10.103 17.9413 10.0839 18.1056L10.0428 18.4596C10.0227 18.6321 9.97204 18.749 9.8959 18.8168ZM5.33122 21.3471C5.50198 21.5542 5.76993 21.6561 6.13088 21.6561C6.49182 21.6561 6.78347 21.5542 7.00236 21.3471C7.22085 21.1405 7.35028 20.85 7.39341 20.4789L7.67385 18.0662C7.71698 17.6952 7.65508 17.4047 7.48463 17.198C7.31387 16.991 7.04592 16.889 6.68497 16.889C6.32403 16.889 6.03238 16.991 5.81349 17.198C5.595 17.4047 5.46557 17.6952 5.42244 18.0662L5.142 20.4789C5.09887 20.85 5.16077 21.1405 5.33122 21.3471ZM6.61516 20.5248C6.59793 20.673 6.55462 20.7798 6.48876 20.8493C6.4237 20.9179 6.33298 20.9539 6.21249 20.9539C6.092 20.9539 6.00966 20.9179 5.96056 20.8493C5.91085 20.7798 5.89236 20.673 5.90959 20.5248L6.20069 18.0203C6.21792 17.8722 6.26123 17.7654 6.3271 17.6959C6.39215 17.6272 6.48287 17.5912 6.60336 17.5912C6.72385 17.5912 6.80619 17.6272 6.85529 17.6959C6.905 17.7654 6.92349 17.8722 6.90626 18.0203L6.61516 20.5248Z"
              stroke="white"
              strokeWidth={0.046875}
            />
          </g>
          <path
            d="M14.2189 22.0256L14.2189 22.0256L14.2183 22.0262C14.1318 22.1137 14.0132 22.1591 13.8586 22.1591H13.5095C13.4415 22.1591 13.3923 22.1043 13.3996 22.0367L13.843 17.9276C13.8503 17.86 13.9114 17.8052 13.9794 17.8052H14.3285C14.4831 17.8052 14.5919 17.8506 14.6595 17.9381L14.6595 17.9381L14.66 17.9387C14.733 18.0262 14.7613 18.1715 14.7387 18.3804L14.393 21.5839C14.3704 21.7928 14.3108 21.9381 14.2189 22.0256ZM22.5393 20.6039L22.5393 20.6039L22.5397 20.6044C22.6172 20.7093 22.6441 20.8985 22.6138 21.1791L22.4923 22.3056C22.4676 22.5343 22.4562 22.6942 22.4585 22.7839C22.4601 22.8437 22.4667 22.906 22.4783 22.9707C22.4909 23.0409 22.552 23.0858 22.6237 23.0858H23.2859C23.4102 23.0858 23.5023 22.9592 23.4892 22.845C23.4853 22.811 23.4833 22.777 23.4832 22.7431L23.4596 22.7456L23.4832 22.7432C23.4834 22.6329 23.493 22.49 23.5119 22.3144L23.6287 21.2319C23.6682 20.8665 23.6496 20.5724 23.5713 20.3511C23.5019 20.1391 23.359 19.9947 23.1443 19.9188C23.5781 19.7357 23.8258 19.3243 23.8935 18.6972L23.9343 18.3188C23.9866 17.8345 23.9099 17.4724 23.699 17.2375C23.4886 16.9965 23.128 16.8785 22.6234 16.8785H21.3271C21.2332 16.8785 21.1489 16.9542 21.1389 17.0476L20.5054 22.9168C20.4953 23.0101 20.5633 23.0858 20.6572 23.0858H21.3378C21.4316 23.0858 21.5159 23.0101 21.526 22.9168L21.7795 20.5679C21.7868 20.5003 21.8479 20.4455 21.9159 20.4455H22.1057C22.3269 20.4455 22.4685 20.5006 22.5393 20.6039ZM22.656 19.376L22.6554 19.3765C22.5569 19.4699 22.4144 19.5188 22.2234 19.5188H22.0159C21.9479 19.5188 21.8987 19.464 21.906 19.3964L22.0645 17.9276C22.0718 17.86 22.1328 17.8052 22.2008 17.8052H22.4969C22.6635 17.8052 22.774 17.8536 22.8349 17.9457L22.8348 17.9457L22.8353 17.9464C22.9026 18.0398 22.9271 18.1945 22.9033 18.4156L22.852 18.8908C22.8269 19.1232 22.7598 19.2828 22.656 19.376ZM14.4463 16.8785H13.1057C13.0118 16.8785 12.9275 16.9542 12.9174 17.0476L12.284 22.9168C12.2739 23.0101 12.3418 23.0858 12.4357 23.0858H13.7763C14.2643 23.0858 14.6485 22.9555 14.9249 22.6911C15.2008 22.4272 15.3641 22.0421 15.4183 21.5399L15.7546 18.4244C15.8088 17.9222 15.7285 17.5372 15.5096 17.2732C15.2903 17.0088 14.9342 16.8785 14.4463 16.8785ZM19.0295 16.8785H17.9598C17.8765 16.8785 17.799 16.9386 17.7767 17.0204L16.1819 22.8896C16.1539 22.9924 16.2237 23.0858 16.3285 23.0858H16.9323C17.0167 23.0858 17.095 23.0242 17.1162 22.9412L17.3598 21.9848C17.3751 21.9247 17.4318 21.8801 17.493 21.8801H18.455L18.496 22.9944C18.4979 23.0468 18.5389 23.0858 18.5922 23.0858H19.321C19.4258 23.0858 19.5157 22.9924 19.51 22.8896L19.182 17.0204C19.1775 16.9386 19.1129 16.8785 19.0295 16.8785ZM18.3253 18.0806L18.4211 20.8578C18.4237 20.9315 18.359 20.9974 18.2841 20.9974H17.7449C17.6701 20.9974 17.6197 20.9317 17.6379 20.8581L18.3253 18.0806ZM22.855 17.9315C22.9269 18.0313 22.9508 18.1926 22.9267 18.4156L22.8754 18.8908C22.8501 19.1255 22.7819 19.2928 22.6708 19.3925L22.855 17.9315ZM27.8046 16.8785H25.4421C25.3483 16.8785 25.264 16.9542 25.2539 17.0476L24.6204 22.9168C24.6104 23.0101 24.6783 23.0858 24.7722 23.0858H27.1347C27.2286 23.0858 27.3129 23.0101 27.3229 22.9168L27.3865 22.3281C27.3965 22.2348 27.3286 22.1591 27.2347 22.1591H25.846C25.7779 22.1591 25.7287 22.1043 25.736 22.0367L25.9088 20.4359C25.9161 20.3683 25.9771 20.3135 26.0451 20.3135H27.0887C27.1826 20.3135 27.2668 20.2378 27.2769 20.1445L27.3404 19.5558C27.3505 19.4625 27.2826 19.3868 27.1887 19.3868H26.1452C26.0772 19.3868 26.0279 19.332 26.0352 19.2644L26.1795 17.9276C26.1868 17.86 26.2479 17.8052 26.3159 17.8052H27.7046C27.7985 17.8052 27.8828 17.7295 27.8929 17.6362L27.9564 17.0476C27.9665 16.9542 27.8985 16.8785 27.8046 16.8785Z"
            fill="white"
            stroke="white"
            strokeWidth={0.046875}
          />
        </g>
        <g filter="url(#filter3_dii_2_31)">
          <path
            d="M16.2967 25.7057C16.3665 25.517 16.6335 25.517 16.7033 25.7057L16.9718 26.4313C16.9938 26.4907 17.0406 26.5375 17.0999 26.5594L17.8255 26.8279C18.0143 26.8978 18.0143 27.1647 17.8255 27.2346L17.0999 27.5031C17.0406 27.525 16.9938 27.5718 16.9718 27.6312L16.7033 28.3568C16.6335 28.5455 16.3665 28.5455 16.2967 28.3568L16.0282 27.6312C16.0062 27.5718 15.9594 27.525 15.9001 27.5031L15.1745 27.2346C14.9857 27.1647 14.9857 26.8978 15.1745 26.8279L15.9001 26.5594C15.9594 26.5375 16.0062 26.4907 16.0282 26.4313L16.2967 25.7057Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter4_dii_2_31)">
          <path
            d="M16.2967 3.67447C16.3665 3.48573 16.6335 3.48573 16.7033 3.67447L16.9718 4.40009C16.9938 4.45943 17.0406 4.50622 17.0999 4.52817L17.8255 4.79668C18.0143 4.86652 18.0143 5.13348 17.8255 5.20332L17.0999 5.47183C17.0406 5.49378 16.9938 5.54057 16.9718 5.59991L16.7033 6.32553C16.6335 6.51427 16.3665 6.51427 16.2967 6.32553L16.0282 5.59991C16.0062 5.54057 15.9594 5.49378 15.9001 5.47183L15.1745 5.20332C14.9857 5.13348 14.9857 4.86652 15.1745 4.79668L15.9001 4.52817C15.9594 4.50622 16.0062 4.45943 16.0282 4.40009L16.2967 3.67447Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_2_31"
          x={0.5}
          y={0}
          width={32}
          height={42.2335}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity={0}
            result="BackgroundImageFix"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={11.4077} />
          <feGaussianBlur stdDeviation={5.11675} />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2={-1}
            k3={1}
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.917647 0 0 0 0 0.101961 0 0 0 0 0.439216 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_2_31"
          />
        </filter>
        <filter
          id="filter1_dii_2_31"
          x={4.13335}
          y={8.56042}
          width={24.8194}
          height={16.1036}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity={0}
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.583089} />
          <feGaussianBlur stdDeviation={0.485908} />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2_31"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2_31"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={-0.0707813} />
          <feGaussianBlur stdDeviation={0.601641} />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2={-1}
            k3={1}
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.980392 0 0 0 0 0.419608 0 0 0 0 0.133333 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_2_31"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={-0.264609} />
          <feGaussianBlur stdDeviation={0.194363} />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2={-1}
            k3={1}
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_2_31"
            result="effect3_innerShadow_2_31"
          />
        </filter>
        <filter
          id="filter2_d_2_31"
          x={4.99195}
          y={16.8658}
          width={6.02369}
          height={5.04006}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity={0}
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.113217} />
          <feGaussianBlur stdDeviation={0.0566084} />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2_31"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2_31"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_dii_2_31"
          x={14.0611}
          y={25.0874}
          width={4.8778}
          height={4.9658}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity={0}
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.583089} />
          <feGaussianBlur stdDeviation={0.485908} />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2_31"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2_31"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={-0.727031} />
          <feGaussianBlur stdDeviation={0.238359} />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2={-1}
            k3={1}
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.980392 0 0 0 0 0.419608 0 0 0 0 0.133333 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_2_31"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={-0.194363} />
          <feGaussianBlur stdDeviation={0.194363} />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2={-1}
            k3={1}
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_2_31"
            result="effect3_innerShadow_2_31"
          />
        </filter>
        <filter
          id="filter4_dii_2_31"
          x={14.0611}
          y={3.05619}
          width={4.8778}
          height={4.9658}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity={0}
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.583089} />
          <feGaussianBlur stdDeviation={0.485908} />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2_31"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2_31"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={-0.727031} />
          <feGaussianBlur stdDeviation={0.238359} />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2={-1}
            k3={1}
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.980392 0 0 0 0 0.419608 0 0 0 0 0.133333 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_2_31"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={-0.194363} />
          <feGaussianBlur stdDeviation={0.194363} />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2={-1}
            k3={1}
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_2_31"
            result="effect3_innerShadow_2_31"
          />
        </filter>
        <clipPath id="clip0_2_31">
          <rect
            width={32}
            height={32}
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const IconDonation = (props) => {
  return (
    <svg
      width={33}
      height={32}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3548_84500)">
        <g filter="url(#filter0_i_3548_84500)">
          <rect
            x={0.5}
            width={32}
            height={32}
            fill="#FD8900"
          />
        </g>
        <g filter="url(#filter1_dii_3548_84500)">
          <path
            d="M16.0571 25.6004C16.1823 25.7283 16.3528 25.7993 16.5313 25.7993C16.7097 25.7993 16.8802 25.7283 17.0055 25.6004L25.5251 16.9679C29.0781 13.3688 26.5535 7.15088 21.5006 7.15088C18.4663 7.15088 17.0738 9.3807 16.5313 9.79718C15.986 9.37892 14.6025 7.15088 11.5619 7.15088C6.52504 7.15088 3.96931 13.3528 7.53827 16.9679L16.0571 25.6004Z"
            fill="white"
          />
        </g>
        <g filter="url(#filter2_dii_3548_84500)">
          <path
            d="M21.8438 25.4375C24.795 25.4375 27.1875 23.045 27.1875 20.0938C27.1875 17.1425 24.795 14.75 21.8438 14.75C18.8925 14.75 16.5 17.1425 16.5 20.0938C16.5 23.045 18.8925 25.4375 21.8438 25.4375Z"
            fill="#267E17"
          />
          <path
            d="M27.1705 20.0938C27.1705 23.0356 24.7856 25.4205 21.8438 25.4205C18.9019 25.4205 16.517 23.0356 16.517 20.0938C16.517 17.1519 18.9019 14.767 21.8438 14.767C24.7856 14.767 27.1705 17.1519 27.1705 20.0938Z"
            stroke="url(#paint0_linear_3548_84500)"
            strokeOpacity={0.5}
            strokeWidth={0.0340466}
            style={{
              mixBlendMode: "overlay",
            }}
          />
        </g>
        <g filter="url(#filter3_dii_3548_84500)">
          <path
            d="M22.3995 19.5381H21.288C20.9545 19.5381 20.7322 19.3158 20.7322 18.9823C20.7322 18.6489 20.9545 18.4266 21.288 18.4266H22.9553C23.2888 18.4266 23.5111 18.2042 23.5111 17.8708C23.5111 17.5373 23.2887 17.315 22.9553 17.315H22.3995C22.3995 16.9816 22.1772 16.7593 21.8438 16.7593C21.5103 16.7593 21.288 16.9816 21.288 17.315C20.3432 17.315 19.6207 18.0375 19.6207 18.9824C19.6207 19.9272 20.3432 20.6497 21.288 20.6497H22.3996C22.7331 20.6497 22.9554 20.872 22.9554 21.2055C22.9554 21.5389 22.733 21.7612 22.3996 21.7612H20.7323C20.3988 21.7612 20.1765 21.9836 20.1765 22.317C20.1765 22.6505 20.3988 22.8728 20.7323 22.8728H21.288C21.288 23.2062 21.5104 23.4285 21.8438 23.4285C22.1773 23.4285 22.3995 23.2062 22.3995 22.8728C23.3444 22.8728 24.0669 22.1503 24.0669 21.2054C24.0669 20.2606 23.3444 19.5381 22.3995 19.5381Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_3548_84500"
          x={0.5}
          y={0}
          width={32}
          height={36.1421}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity={0}
            result="BackgroundImageFix"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={4.14213} />
          <feGaussianBlur stdDeviation={5.11675} />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2={-1}
            k3={1}
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3548_84500"
          />
        </filter>
        <filter
          id="filter1_dii_3548_84500"
          x={4.42725}
          y={5.59254}
          width={24.205}
          height={22.5217}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity={0}
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.868111} />
          <feGaussianBlur stdDeviation={0.723426} />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3548_84500"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3548_84500"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={-1.55834} />
          <feGaussianBlur stdDeviation={2.38497} />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2={-1}
            k3={1}
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.929412 0 0 0 0 0.556863 0 0 0 0 0 0 0 0 0.55 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_3548_84500"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={-0.28937} />
          <feGaussianBlur stdDeviation={0.28937} />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2={-1}
            k3={1}
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_3548_84500"
            result="effect3_innerShadow_3548_84500"
          />
        </filter>
        <filter
          id="filter2_dii_3548_84500"
          x={15.597}
          y={14.3888}
          width={12.4934}
          height={14.0572}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity={0}
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.541778} />
          <feGaussianBlur stdDeviation={0.451481} />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3548_84500"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3548_84500"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={3.00854} />
          <feGaussianBlur stdDeviation={3.71644} />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2={-1}
            k3={1}
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
          />
          <feBlend
            mode="overlay"
            in2="shape"
            result="effect2_innerShadow_3548_84500"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.455033} />
          <feGaussianBlur stdDeviation={1.0214} />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2={-1}
            k3={1}
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
          />
          <feBlend
            mode="overlay"
            in2="effect2_innerShadow_3548_84500"
            result="effect3_innerShadow_3548_84500"
          />
        </filter>
        <filter
          id="filter3_dii_3548_84500"
          x={19.1134}
          y={16.4042}
          width={5.46079}
          height={7.83622}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity={0}
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.304379} />
          <feGaussianBlur stdDeviation={0.253649} />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3548_84500"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3548_84500"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={-0.355109} />
          <feGaussianBlur stdDeviation={0.405839} />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2={-1}
            k3={1}
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.14902 0 0 0 0 0.494118 0 0 0 0 0.0901961 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_3548_84500"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={-0.10146} />
          <feGaussianBlur stdDeviation={0.10146} />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2={-1}
            k3={1}
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_3548_84500"
            result="effect3_innerShadow_3548_84500"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3548_84500"
          x1={21.8438}
          y1={14.75}
          x2={21.8438}
          y2={25.4375}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop
            offset={1}
            stopColor="white"
            stopOpacity={0}
          />
        </linearGradient>
        <clipPath id="clip0_3548_84500">
          <rect
            width={32}
            height={32}
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const IconVideoShoutout = (props) => (
  <img
    {...props}
    src="https://i.ecomobi.com/ssp/Video-shoutout/video-shoutout-icon.png"
  />
);

export const SpacerAndDividerIcon = (props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_i_36079_317161)">
        <rect
          width="48"
          height="48"
          rx="8"
          fill="#0A72FB"
        />
        <g filter="url(#filter1_dii_36079_317161)">
          <path
            d="M19.5 17.5C19.5 18.8807 18.3807 20 17 20C15.6193 20 14.5 18.8807 14.5 17.5C14.5 16.1193 15.6193 15 17 15C18.3807 15 19.5 16.1193 19.5 17.5Z"
            fill="white"
          />
          <path
            d="M26.5 17.5C26.5 18.8807 25.3807 20 24 20C22.6193 20 21.5 18.8807 21.5 17.5C21.5 16.1193 22.6193 15 24 15C25.3807 15 26.5 16.1193 26.5 17.5Z"
            fill="white"
          />
          <path
            d="M31 20C32.3807 20 33.5 18.8807 33.5 17.5C33.5 16.1193 32.3807 15 31 15C29.6193 15 28.5 16.1193 28.5 17.5C28.5 18.8807 29.6193 20 31 20Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 12C8 9.79086 9.79086 8 12 8H36C38.2091 8 40 9.79086 40 12V36C40 38.2091 38.2091 40 36 40H12C9.79086 40 8 38.2091 8 36V12ZM12 11H36C36.5523 11 37 11.4477 37 12V36C37 36.5523 36.5523 37 36 37H12C11.4477 37 11 36.5523 11 36V12C11 11.4477 11.4477 11 12 11Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_36079_317161"
          x="0"
          y="0"
          width="48"
          height="56.2843"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8.28426" />
          <feGaussianBlur stdDeviation="10.2335" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_36079_317161"
          />
        </filter>
        <filter
          id="filter1_dii_36079_317161"
          x="6.76"
          y="7.13"
          width="34.605"
          height="34.985"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.75" />
          <feGaussianBlur stdDeviation="0.62" />
          <feComposite
            in2="hardAlpha"
            operator="out"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_36079_317161"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_36079_317161"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.87" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.113725 0 0 0 0 0.67451 0 0 0 0 0.360784 0 0 0 0.35 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_36079_317161"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.25" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite
            in2="hardAlpha"
            operator="arithmetic"
            k2="-1"
            k3="1"
          />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_innerShadow_36079_317161"
            result="effect3_innerShadow_36079_317161"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const CombinedBlockIcon = ({ width = 48, height = 48 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_1908_368244)">
      <rect
        width="48"
        height="48"
        rx="8"
        fill="#12AD56"
      />
      <g filter="url(#filter1_dii_1908_368244)">
        <mask
          id="path-2-inside-1_1908_368244"
          fill="white"
        >
          <path d="M8 12C8 9.79086 9.79086 8 12 8H36C38.2091 8 40 9.79086 40 12V36C40 38.2091 38.2091 40 36 40H12C9.79086 40 8 38.2091 8 36V12Z" />
        </mask>
        <path
          d="M12 11H36V5H12V11ZM37 12V36H43V12H37ZM36 37H12V43H36V37ZM11 36V12H5V36H11ZM12 37C11.4477 37 11 36.5523 11 36H5C5 39.866 8.13401 43 12 43V37ZM37 36C37 36.5523 36.5523 37 36 37V43C39.866 43 43 39.866 43 36H37ZM36 11C36.5523 11 37 11.4477 37 12H43C43 8.13401 39.866 5 36 5V11ZM12 5C8.13401 5 5 8.13401 5 12H11C11 11.4477 11.4477 11 12 11V5Z"
          fill="white"
          mask="url(#path-2-inside-1_1908_368244)"
        />
        <path
          d="M15 17C15 15.8954 15.8954 15 17 15H31C32.1046 15 33 15.8954 33 17V20.4483C33 21.5529 32.1046 22.4483 31 22.4483H17C15.8954 22.4483 15 21.5529 15 20.4483V17Z"
          fill="white"
        />
        <path
          d="M15 27.4483C15 26.3437 15.8954 25.4483 17 25.4483H31C32.1046 25.4483 33 26.3437 33 27.4483V30.8966C33 32.0012 32.1046 32.8966 31 32.8966H17C15.8954 32.8966 15 32.0012 15 30.8966V27.4483Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_i_1908_368244"
        x="0"
        y="0"
        width="48"
        height="56.2843"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8.28426" />
        <feGaussianBlur stdDeviation="10.2335" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1908_368244"
        />
      </filter>
      <filter
        id="filter1_dii_1908_368244"
        x="6.76"
        y="7.13"
        width="34.605"
        height="34.985"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.75" />
        <feGaussianBlur stdDeviation="0.62" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1908_368244"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1908_368244"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.87" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.113725 0 0 0 0 0.67451 0 0 0 0 0.360784 0 0 0 0.35 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_1908_368244"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-0.25" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_innerShadow_1908_368244"
          result="effect3_innerShadow_1908_368244"
        />
      </filter>
    </defs>
  </svg>
);

export const BookingProfileBlockIcon = ({ width = 48, height = 48, className = "" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} viewBox="0 0 1024 1024" fill="none">
    <g clipPath="url(#clip0_2462_25036)">
      <g filter="url(#filter0_i_2462_25036)">
        <rect width="1024" height="1024" fill="#FF0066" />
        <rect width="1024" height="1024" fill="white" fill-opacity="0.2" />
      </g>
      <path d="M882 512C882 307.654 716.345 142 512 142C307.655 142 142 307.654 142 512C142 716.345 307.655 881.999 512 881.999C716.345 881.999 882 716.345 882 512Z" stroke="url(#paint0_linear_2462_25036)" strokeWidth="40" />
      <g filter="url(#filter1_dii_2462_25036)">
        <path fillRule="evenodd" clipRule="evenodd" d="M711.619 647.82C815.878 587.346 815.878 436.791 711.619 376.316L524.248 267.631C419.624 206.944 288.568 282.433 288.568 403.384L288.568 620.753C288.568 741.704 419.624 817.192 524.248 756.505L711.619 647.82ZM629.184 540.87C651.311 528.044 651.311 496.094 629.184 483.268L471.958 392.131C449.764 379.267 421.973 395.28 421.973 420.933L421.973 603.206C421.973 628.858 449.764 644.871 471.958 632.007L629.184 540.87Z" fill="white" />
        <rect x="288.569" y="564.179" width="133.396" height="236.087" fill="white" />
        <path d="M288.568 935.156C390.862 926.13 420.121 848.879 421.965 811.381V780.267H288.568V935.156Z" fill="white" />
      </g>
    </g>
    <defs>
      <filter id="filter0_i_2462_25036" x="0" y="0" width="1024" height="1240.73" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feMorphology radius="57" operator="erode" in="SourceAlpha" result="effect1_innerShadow_2462_25036" />
        <feOffset dy="216.73" />
        <feGaussianBlur stdDeviation="218.315" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.709804 0 0 0 0 0 0 0 0 0 0.698039 0 0 0 1 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2462_25036" />
      </filter>
      <filter id="filter1_dii_2462_25036" x="271.236" y="227.544" width="535.91" height="735.344" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="10.3993" />
        <feGaussianBlur stdDeviation="8.6661" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2462_25036" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2462_25036" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="-18.6677" />
        <feGaussianBlur stdDeviation="54.0247" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0 0 0 0 0 0.4 0 0 0 0.55 0" />
        <feBlend mode="normal" in2="shape" result="effect2_innerShadow_2462_25036" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="-3.46644" />
        <feGaussianBlur stdDeviation="3.46644" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.63 0" />
        <feBlend mode="normal" in2="effect2_innerShadow_2462_25036" result="effect3_innerShadow_2462_25036" />
      </filter>
      <linearGradient id="paint0_linear_2462_25036" x1="512" y1="901.999" x2="512" y2="122" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FF98D0" stop-opacity="0" />
        <stop offset="1" stop-color="#FF98D0" />
      </linearGradient>
      <clipPath id="clip0_2462_25036">
        <rect width="1024" height="1024" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
